import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  InputGroup,
  InputRightElement,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Skeleton,
  Switch,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import iconPlus2 from "../../assets/images/personnelCategories/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import {
  exportFile,
  formatDateDb,
  roundNumber,
  roundNumber0,
} from "../../utils/tools";
import { delay, formatDateToLocal, formatPriceUS } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { lockingRelativeParticipantCall } from "../../api/lockingRelativeParticipant";
import { formatTableValue } from "./formatTable";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm, useWatch } from "react-hook-form";
import {
  InputControl,
  SelectControl,
} from "../../components/form/formControls";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { commissionCall } from "../../api/commission";
import StepEmployeeForm from "./step3EmployeeForm";
import StepManagerForm from "./step3ManagerForm";
import Step3ManagerBlockAreaForm from "./step3ManagerBlockAreaForm";
import DeleteDialog from "../../components/dialog/delete";
import { GrPowerReset } from "react-icons/gr";
import Step3FinalServiceFeeForm from "./step3FinalServiceFeeForm";
import { saleOpeningEventMechanismParametersCall } from "../../api/saleOpeningEventMechanismParameters";
import SearchableSelect from "../../components/selectForm";
import { ConfirmCommissionStatus } from "./constants";
import { IconButton, SlideFade, Stack } from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { HStack, Badge } from "@chakra-ui/react";
import { FiAlertTriangle } from "react-icons/fi";
import { attendanceCall } from "../../api/attendance";
import { clientAPI } from "../../api/client";
import Decimal from "decimal.js";

// ─── Decimal helpers ───────────────────────────────────────────────────────
const D = (v) => {
  try {
    const d = new Decimal(v ?? 0);
    return d.isFinite() ? d : new Decimal(0);
  } catch {
    return new Decimal(0);
  }
};
const safeDivD = (a, b, fallback = 0) => {
  const db = D(b);
  return db.isZero() ? new Decimal(fallback) : D(a).div(db);
};
// ──────────────────────────────────────────────────────────────────────────

const schemaEdit = Yup.object().shape({
  transactionRate: Yup.number()
    .nullable()
    // .transform((value, originalValue) => {
    //   if (typeof originalValue === "string") {
    //     return originalValue.trim() === "" ? null : Number(originalValue);
    //   }
    //   return originalValue === null ? null : Number(originalValue);
    // })
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        const s = originalValue.trim();
        if (s === "") return null;
        return Number(s.replace(",", "."));
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Tỉ lệ giao dịch là bắt buộc"),
  standardWorkingDaysInMonth: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Ngày công chuẩn trong tháng là bắt buộc"),
  incomeRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Tỉ lệ TN MSH là bắt buộc"),
  platformIncomeRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Tỉ lệ TN sàn là bắt buộc"),
  salesCommissionRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Tỉ lệ PDV CVKD là bắt buộc"),
  eliteSalesCommissionRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Tỉ lệ PDV CVKD Elite là bắt buộc"),
  period: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Số đợt là bắt buộc"),
  month: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .min(1, "Tháng phải từ 1-12")
    .max(12, "Tháng phải từ 1-12")
    .optional(),
  year: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .min(2000, "Năm không hợp lệ")
    .optional(),
  calculateCommissionRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("TTDA là bắt buộc"),
  priceForCommission: Yup.string().required("Số tiền phí dịch vụ là bắt buộc"),
  kRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Hệ số k là bắt buộc"),
  saleOpeningEventMechanismParametersId:
    Yup.string().required("Vui lòng hệ số k"),
});

export default memo(function StepCommissionForm({
  step,
  lockingId,
  locking,
  getLocking,
}) {
  const {
    control,
    register,
    setValue,
    handleSubmit,
    watch,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaEdit),
    defaultValues:
      {
        ...locking,
        priceForCommission: Number(
          locking?.apartment?.priceForCommission ||
            locking?.apartment?.saleOpeningEventMechanismParameters
              ?.priceForCommission ||
            0,
        ),
        standardWorkingDaysInMonth: locking?.standardWorkingDaysInMonth,
        period: step.period,
        month: step.month ?? null,
        year: step.year ?? null,
        calculateCommissionRate: step.calculateCommissionRate,
        transactionRate: Number(locking?.apartment?.transactionRate || 100),
      } || {},
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenApproved,
    onOpen: onOpenApproved,
    onClose: onCloseApproved,
  } = useDisclosure();
  const bottomRef = useRef(null);
  const scrollToBottom = () => {
    requestAnimationFrame(() => {
      bottomRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    });
  };
  const [isActionOpen, setIsActionOpen] = useState(false);

  // Tháng/Năm đối chiếu — dùng Date object để feed cho DatePicker (showMonthYearPicker)
  const [monthYearDate, setMonthYearDate] = useState(
    step?.month && step?.year ? new Date(step.year, step.month - 1, 1) : null,
  );

  const handleMonthYearChange = (d) => {
    setMonthYearDate(d);
    if (d) {
      setValue("month", d.getMonth() + 1, { shouldValidate: true });
      setValue("year", d.getFullYear(), { shouldValidate: true });
    } else {
      setValue("month", null, { shouldValidate: true });
      setValue("year", null, { shouldValidate: true });
    }
  };
  const [stepHandle, setStepHandle] = useState(0);
  const [stepHandleRate, setStepHandleRate] = useState([]);
  const [isShowConfirm, setIsShowConfirm] = useState(true);
  const [relativeParticipant, setRelativeParticipant] = useState([]);
  const [saleBlockManagers, setSaleBlockManagers] = useState([]);
  const [saleAreaManagers, setSaleAreaManagers] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [managers, setManagers] = useState([]);
  const [finalEmployees, setFinalEmployees] = useState([]);

  const [checkedSwitch, setCheckedSwitch] = useState(true);

  const [mechanismParameters, setMechanismParameters] = useState(null);

  const [dataKRate, setDataKRate] = useState([]);
  const [periodCompensation, setPeriodCompensation] = useState([]);

  const [kRateChangedByUser, setKRateChangedByUser] = useState(false);

  const hasInfoTransactionRateRef = useRef(false); // có data.informationForm.transactionRate không
  const kRateChangedByUserRef = useRef(false); // user thực sự đổi hệ số k

  // Tổng phí dịch vụ nhân viên tham gia
  const [
    totalRelativeParticipantIncomePrice,
    setTotalRelativeParticipantIncomePrice,
  ] = useState(0);
  const onChangeTotalRelativeParticipantIncomePrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setTotalRelativeParticipantIncomePrice(formatPriceUS(numericValue));
      setValue("totalRelativeParticipantIncomePrice", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue],
  );
  const [
    totalRelativeParticipantCommission,
    setTotalRelativeParticipantCommission,
  ] = useState(0);
  const onChangeTotalRelativeParticipantCommission = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setTotalRelativeParticipantCommission(formatPriceUS(numericValue));
      setValue("totalRelativeParticipantCommission", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue],
  );

  // Tổng PDV giám đốc khối
  const [
    totalSaleBlockManagerCommissionPrice,
    setTotalSaleBlockManagerCommissionPrice,
  ] = useState(0);
  const onChangeTotalSaleBlockManagerCommissionPrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setTotalSaleBlockManagerCommissionPrice(formatPriceUS(numericValue));
      setValue("totalSaleBlockManagerCommissionPrice", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue],
  );
  // Tổng PDV giám đốc vùng
  const [
    totalSaleAreaManagerCommissionPrice,
    setTotalSaleAreaManagerCommissionPrice,
  ] = useState(0);
  const onChangeTotalSaleAreaManagerCommissionPrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setTotalSaleAreaManagerCommissionPrice(formatPriceUS(numericValue));
      setValue("totalSaleAreaManagerCommissionPrice", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue],
  );
  // Tổng PDV người GT
  const [totalReferralsCommissionPrice, setTotalReferralsCommissionPrice] =
    useState(0);
  const onChangeTotalReferralsCommissionPrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setTotalReferralsCommissionPrice(formatPriceUS(numericValue));
      setValue("totalReferralsCommissionPrice", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue],
  );
  // Tổng tất cả PDV
  const [totalAllCommissionPrice, setTotalAllCommissionPrice] = useState([]);
  const [totalFinalServiceFee, setTotalFinalServiceFee] = useState({
    commissionPrice: 0, // số tiền
    bonus: 0, // Nhập thưởng khác
    certificateOrDeposit: 0, // Chứng chỉ/ ký quỹ
    accountingFromPreviousPeriodOrAdvance: 0, // KT do đã DC kỳ trước/Đã tạm ứng/KT khác
    remainingRevenueAfterAccounting: 0, // PDV còn lại sau KT
    personalIncomeTax: 0, // Thuế TNCN
    remainingRevenueAfterTax: 0, // PDV còn lại sau thuế
  });
  const onChangeTotalAllCommissionPrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setTotalAllCommissionPrice(formatPriceUS(numericValue));
      setValue("totalAllCommissionPrice", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue],
  );

  const getLockingManagerRelativeParticipant = async (lockingId, period) => {
    const participants =
      await lockingRelativeParticipantCall.getManagerRelativeParticipantsForCalculateByLockingId(
        lockingId,
      );

    if (participants?.employees) {
      setRelativeParticipant(participants?.employees);
    }

    if (participants?.saleBlockManagers) {
      setSaleBlockManagers(participants?.saleBlockManagers);
    }

    if (participants?.saleAreaManagers) {
      setSaleAreaManagers(participants?.saleAreaManagers);
    }

    if (participants?.referrals) {
      setReferrals(participants?.referrals);
    }

    if (participants?.managers) {
      setManagers(participants?.managers);
    }
  };

  const getFormData = async (lockingId, period, locking) => {
    setIsLoading(true);
    const data = await lockingCall.getCalculateCommission(lockingId, period);
    if (data) {
      // check
      hasInfoTransactionRateRef.current = false;
      kRateChangedByUserRef.current = false;
      setKRateChangedByUser(false);

      if (data?.saleOpeningEventMechanismParametersId) {
        setValue(
          "saleOpeningEventMechanismParametersId",
          data?.saleOpeningEventMechanismParametersId,
        );
      }
      if (data?.informationForm) {
        if (data?.informationForm?.kRate) {
          setValue("kRate", Number(data.informationForm.kRate), {
            shouldValidate: true,
          });
        }
        if (data?.informationForm?.calculateCommissionRate) {
          setValue(
            "calculateCommissionRate",
            Number(data.informationForm.calculateCommissionRate),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.priceForCommission) {
          setDisplayPrice(
            formatPriceUS(Number(data.informationForm.priceForCommission || 0)),
          );
          setValue(
            "priceForCommission",
            Number(data.informationForm.priceForCommission),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.priceTNSan) {
          setDisplayPriceTN(
            formatPriceUS(Number(data.informationForm.priceTNSan || 0)),
          );
          setValue(
            "priceTNSan",
            roundNumber0(Number(data.informationForm.priceTNSan)),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.standardWorkingDaysInMonth) {
          setValue(
            "standardWorkingDaysInMonth",
            Number(data.informationForm.standardWorkingDaysInMonth),
            {
              shouldValidate: true,
            },
          );
        }
        // if (data?.informationForm?.transactionRate) {
        //   setValue(
        //     "transactionRate",
        //     Number(data.informationForm.transactionRate),
        //     {
        //       shouldValidate: true,
        //     }
        //   );
        // }

        //check
        if (
          data?.informationForm?.transactionRate !== undefined &&
          data?.informationForm?.transactionRate !== null
        ) {
          hasInfoTransactionRateRef.current = true;
          setValue(
            "transactionRate",
            Number(data.informationForm.transactionRate),
            {
              shouldValidate: true,
            },
          );
        }

        if (data?.informationForm?.incomeRate) {
          setValue("incomeRate", Number(data.informationForm.incomeRate), {
            shouldValidate: true,
          });
        }
        if (data?.informationForm?.platformIncomeRate) {
          setValue(
            "platformIncomeRate",
            Number(data.informationForm.platformIncomeRate),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.salesCommissionRate) {
          setValue(
            "salesCommissionRate",
            Number(data.informationForm.salesCommissionRate),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.eliteSalesCommissionRate) {
          setValue(
            "eliteSalesCommissionRate",
            Number(data.informationForm.eliteSalesCommissionRate),
            {
              shouldValidate: true,
            },
          );
        }

        // Tháng/Năm — ưu tiên từ informationForm đã lưu, fallback step
        {
          const _m =
            data?.informationForm?.month != null
              ? Number(data.informationForm.month)
              : step?.month != null
                ? Number(step.month)
                : null;
          const _y =
            data?.informationForm?.year != null
              ? Number(data.informationForm.year)
              : step?.year != null
                ? Number(step.year)
                : null;
          if (_m != null) setValue("month", _m, { shouldValidate: true });
          if (_y != null) setValue("year", _y, { shouldValidate: true });
          setMonthYearDate(
            _m != null && _y != null ? new Date(_y, _m - 1, 1) : null,
          );
        }

        if (data?.informationForm?.displayReferralPrice) {
          setDisplayReferralPrice(
            formatPriceUS(data.informationForm.displayReferralPrice || 0),
          );
          setValue(
            "displayReferralPrice",
            roundNumber0(Number(data.informationForm.displayReferralPrice)),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.commissionRateBlockManagerDH) {
          setValue(
            "commissionRateBlockManagerDH",
            Number(data.informationForm.commissionRateBlockManagerDH),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.commissionRateBlockManagerDT) {
          setValue(
            "commissionRateBlockManagerDT",
            Number(data.informationForm.commissionRateBlockManagerDT),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.commissionRateBlockManagerCL) {
          setValue(
            "commissionRateBlockManagerCL",
            Number(data.informationForm.commissionRateBlockManagerCL),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.commissionRateAreaManagerDH) {
          setValue(
            "commissionRateAreaManagerDH",
            Number(data.informationForm.commissionRateAreaManagerDH),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.commissionRateAreaManagerDT) {
          setValue(
            "commissionRateAreaManagerDT",
            Number(data.informationForm.commissionRateAreaManagerDT),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.commissionRateAreaManagerCL) {
          setValue(
            "commissionRateAreaManagerCL",
            Number(data.informationForm.commissionRateAreaManagerCL),
            {
              shouldValidate: true,
            },
          );
        }
        if (data?.informationForm?.commissionRateGeneralDirector) {
          setValue(
            "commissionRateGeneralDirector",
            Number(data.informationForm.commissionRateGeneralDirector),
            {
              shouldValidate: true,
            },
          );
        }
      }

      if (data?.relativeParticipantForm) {
        if (data?.relativeParticipantForm?.list) {
          // Đồng bộ cờ isElite từ chấm công hiện tại (theo transactionDate của locking)
          // để FE khớp với BE (bulkCalculator luôn lấy isElite mới từ Attendance).
          const _attDate = locking?.transactionDate
            ? new Date(locking.transactionDate)
            : new Date();
          const _attMonth = _attDate.getMonth() + 1;
          const _attYear = _attDate.getFullYear();

          const enrichedList = await Promise.all(
            (data.relativeParticipantForm.list || []).map(async (p) => {
              const attEmployeeId =
                p?.isCollaborator && p?.relativeId
                  ? p.relativeId
                  : p?.employeeId;
              if (!attEmployeeId) return p;
              try {
                const att = await attendanceCall.getByEmployee(
                  attEmployeeId,
                  _attMonth,
                  _attYear,
                );
                return { ...p, isElite: att?.isElite === true };
              } catch {
                return p;
              }
            }),
          );

          setRelativeParticipant(enrichedList);
        }

        if (data?.relativeParticipantForm?.totals) {
          // set State
          if (
            data?.relativeParticipantForm?.totals
              ?.totalRelativeParticipantIncomePrice
          ) {
            const totalRelativeParticipantIncomePrice =
              data?.relativeParticipantForm?.totals
                ?.totalRelativeParticipantIncomePrice || 0;
            setTotalRelativeParticipantIncomePrice(
              formatPriceUS(totalRelativeParticipantIncomePrice),
            );
            setValue(
              "totalRelativeParticipantIncomePrice",
              roundNumber0(Number(totalRelativeParticipantIncomePrice)),
              {
                shouldValidate: true,
              },
            );
          }

          if (
            data?.relativeParticipantForm?.totals
              ?.totalRelativeParticipantCommissionPrice
          ) {
            const totalRelativeParticipantCommissionPrice =
              data?.relativeParticipantForm?.totals
                ?.totalRelativeParticipantCommissionPrice || 0;
            setTotalRelativeParticipantCommission(
              formatPriceUS(totalRelativeParticipantCommissionPrice),
            );
            setValue(
              "totalRelativeParticipantCommission",
              roundNumber0(Number(totalRelativeParticipantCommissionPrice)),
              {
                shouldValidate: true,
              },
            );
          }
        }
      }

      if (data?.saleBlockManagersForm) {
        if (data?.saleBlockManagersForm?.list) {
          setSaleBlockManagers(data.saleBlockManagersForm.list);
        }

        if (data?.saleBlockManagersForm?.totals) {
          if (
            data?.saleBlockManagersForm?.totals
              ?.totalSaleBlockManagerCommissionRate
          ) {
            const totalSaleBlockManagerCommissionRate =
              data?.saleBlockManagersForm?.totals
                ?.totalSaleBlockManagerCommissionRate;

            setValue(
              "totalSaleBlockManagerCommissionRate",
              Number(totalSaleBlockManagerCommissionRate),
              {
                shouldValidate: true,
              },
            );
          }

          if (
            data?.saleBlockManagersForm?.totals
              ?.totalSaleBlockManagerCommissionPrice
          ) {
            const totalSaleBlockManagerCommissionPrice =
              data?.saleBlockManagersForm?.totals
                ?.totalSaleBlockManagerCommissionPrice;

            setTotalSaleBlockManagerCommissionPrice(
              formatPriceUS(totalSaleBlockManagerCommissionPrice),
            );
            setValue(
              "totalSaleBlockManagerCommissionPrice",
              roundNumber0(Number(totalSaleBlockManagerCommissionPrice)),
              {
                shouldValidate: true,
              },
            );
          }
        }
      }

      if (data?.saleAreaManagersForm) {
        if (data?.saleAreaManagersForm?.list) {
          setSaleAreaManagers(data.saleAreaManagersForm.list);
        }

        if (data?.saleAreaManagersForm?.totals) {
          if (data?.saleAreaManagersForm?.totals) {
            if (
              data?.saleAreaManagersForm?.totals
                ?.totalSaleAreaManagerCommissionRate
            ) {
              const totalSaleAreaManagerCommissionRate =
                data?.saleAreaManagersForm?.totals
                  ?.totalSaleAreaManagerCommissionRate;

              setValue(
                "totalSaleAreaManagerCommissionRate",
                Number(totalSaleAreaManagerCommissionRate),
                {
                  shouldValidate: true,
                },
              );
            }

            if (
              data?.saleAreaManagersForm?.totals
                ?.totalSaleAreaManagerCommissionPrice
            ) {
              const totalSaleAreaManagerCommissionPrice =
                data?.saleAreaManagersForm?.totals
                  ?.totalSaleAreaManagerCommissionPrice;

              setTotalSaleAreaManagerCommissionPrice(
                formatPriceUS(totalSaleAreaManagerCommissionPrice),
              );
              setValue(
                "totalSaleAreaManagerCommissionPrice",
                roundNumber0(Number(totalSaleAreaManagerCommissionPrice)),
                {
                  shouldValidate: true,
                },
              );
            }
          }
        }
      }

      if (data?.referralsForm) {
        if (data?.referralsForm?.list) {
          setReferrals(data.referralsForm.list);
        }

        if (data?.referralsForm?.totals) {
          if (data?.referralsForm?.totals?.totalReferralsCommissionRate) {
            const totalReferralsCommissionRate =
              data?.referralsForm?.totals?.totalReferralsCommissionRate;

            setValue(
              "totalReferralsCommissionRate",
              Number(totalReferralsCommissionRate),
              {
                shouldValidate: true,
              },
            );
          }

          if (data?.referralsForm?.totals?.totalReferralsCommissionPrice) {
            const totalReferralsCommissionPrice =
              data?.referralsForm?.totals?.totalReferralsCommissionPrice;

            setTotalReferralsCommissionPrice(
              formatPriceUS(totalReferralsCommissionPrice),
            );
            setValue(
              "totalReferralsCommissionPrice",
              roundNumber0(Number(totalReferralsCommissionPrice)),
              {
                shouldValidate: true,
              },
            );
          }
        }

        if (data?.referralsForm?.checkedSwitch) {
          setCheckedSwitch(data?.referralsForm.checkedSwitch);
        } else {
          setCheckedSwitch(false);
        }
      }

      if (data?.managersForm) {
        if (data?.managersForm?.list) {
          setManagers(data.managersForm.list);
        }

        if (data?.managersForm?.totals) {
          if (data?.managersForm?.totals?.totalAllCommissionRate) {
            const totalAllCommissionRate =
              data?.managersForm?.totals?.totalAllCommissionRate;

            setValue("totalAllCommissionRate", Number(totalAllCommissionRate), {
              shouldValidate: true,
            });
          }

          if (data?.managersForm?.totals?.totalAllCommissionPrice) {
            const totalAllCommissionPrice =
              data?.managersForm?.totals?.totalAllCommissionPrice;
            setTotalAllCommissionPrice(formatPriceUS(totalAllCommissionPrice));
            setValue(
              "totalAllCommissionPrice",
              roundNumber0(Number(totalAllCommissionPrice)),
              {
                shouldValidate: true,
              },
            );
          }
        }
      }

      if (data?.finalEmployeesForm) {
        if (data?.finalEmployeesForm?.list) {
          setFinalEmployees(data.finalEmployeesForm.list);
        }

        if (data?.finalEmployeesForm?.totals) {
          setTotalFinalServiceFee(data.finalEmployeesForm.totals);
        }
      }

      setIsLoading(false);
      if (data?.confirmCommissionStatus === ConfirmCommissionStatus.APPROVED)
        setIsShowConfirm(false);
      setIsCalculate(true);
      setIsCalculateFinalServiceFee(true);
      setIsConfirmCommissionStatus(true);
    } else {
      // check
      hasInfoTransactionRateRef.current = false;
      kRateChangedByUserRef.current = false;
      setKRateChangedByUser(false);

      getLockingManagerRelativeParticipant(lockingId);
      setDisplayPrice(
        formatPriceUS(
          locking?.apartment?.priceForCommission ||
            locking?.apartment?.saleOpeningEventMechanismParameters
              ?.priceForCommission ||
            0,
        ),
      );
      setDisplayPriceTN(formatPriceUS(locking?.apartment?.priceTNSan || 0));
      setDisplayReferralPrice(formatPriceUS("5000000"));
      setValue("displayReferralPrice", Number(5000000), {
        shouldValidate: true,
      });
      // Tạo mới (chưa có data lưu) → mặc định tháng/năm hiện tại
      const _now = new Date();
      setValue("month", _now.getMonth() + 1, { shouldValidate: true });
      setValue("year", _now.getFullYear(), { shouldValidate: true });
      setMonthYearDate(_now);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  // lấy ra thông tin chung
  const getMechanism = async (saleOpeningEventMechanismParametersId) => {
    setMechanismParameters({});
    if (saleOpeningEventMechanismParametersId) {
      // const shouldOverrideTransactionRate =
      //   !hasInfoTransactionRateRef.current || kRateChangedByUserRef.current;

      const saleOpeningEventMechanismParameters =
        await saleOpeningEventMechanismParametersCall.getById(
          saleOpeningEventMechanismParametersId,
        );

      // check
      const shouldOverrideTransactionRate =
        !hasInfoTransactionRateRef.current || kRateChangedByUserRef.current;

      // Tính toán kRate và các tỉ lệ
      const dataKRate = {};
      const saleOpeningEventMechanismParametersData =
        saleOpeningEventMechanismParameters?.data;

      const CHUNG = saleOpeningEventMechanismParametersData.find(
        (item) => item.code === "CHUNG",
      );
      const CVKD = saleOpeningEventMechanismParametersData?.find(
        (item) => item.code === "CVKD",
      );
      const GDK = saleOpeningEventMechanismParametersData?.find(
        (item) => item.code === "GDK",
      );
      const TOTAL = saleOpeningEventMechanismParametersData?.find(
        (item) => item.code === "TOTAL",
      );

      const CVKD_ELITE = saleOpeningEventMechanismParametersData?.find(
        (item) => item.code === "CVKD_ELITE",
      );

      // ── Decimal: tính kRate và các tỉ lệ ────────────────────────────────
      // Công thức khớp với calculateSummaryOnly (tableUpdateProjectMechanism):
      //   INCLUDED_ELITE (mặc định): kRate = GDK.mechanismRateElite / GDK.mechanismRate
      //   NOT_INCLUDED_ELITE:        kRate = CVKD_ELITE.mechanismRateElite / CVKD_ELITE.mechanismRate
      const cvkdRateMode =
        saleOpeningEventMechanismParameters?.cvkdRateMode || "INCLUDED_ELITE";

      // Tỉ lệ CVKD.mechanismRateElite — dùng cho tính TN MSH
      const mechanismRateEliteCVKD = parseFloat(CVKD?.mechanismRateElite) || 0;

      // kRate tính theo đúng mode
      const kRateCalc =
        cvkdRateMode === "NOT_INCLUDED_ELITE"
          ? safeDivD(
              D(CVKD_ELITE?.mechanismRateElite),
              CVKD_ELITE?.mechanismRate || 1,
            ).toNumber()
          : safeDivD(
              D(GDK?.mechanismRateElite),
              GDK?.mechanismRate || 1,
            ).toNumber();
      // ────────────────────────────────────────────────────────────────────

      dataKRate.transactionRate = Number(
        saleOpeningEventMechanismParameters?.transactionRate || 0,
      );

      //Tỉ lệ PDV kRate
      const kRateData =
        Number(saleOpeningEventMechanismParameters?.statusKRate) === 2
          ? saleOpeningEventMechanismParameters?.kRate
          : kRateCalc;
      dataKRate.kRate = kRateData || 0;

      //Tỉ lệ PDV CVKD mặc định
      const rateDefaultData =
        saleOpeningEventMechanismParameters?.rateDefault || 1.5;
      dataKRate.salesCommissionRate =
        rateDefaultData || Number(getValues("salesCommissionRate")) || 0;

      //Tỉ lệ PDV CVKD
      const rateData =
        Number(saleOpeningEventMechanismParameters?.statusKRate) === 2
          ? saleOpeningEventMechanismParameters?.rate
          : kRateCalc * rateDefaultData >= 0
            ? kRateCalc * rateDefaultData
            : 0;

      //Tỉ lệ PDV CVKD Elite mặc định
      const rateEliteDefaultData =
        saleOpeningEventMechanismParameters?.rateEliteDefault || 0.2;
      dataKRate.eliteSalesCommissionRate =
        rateEliteDefaultData ||
        Number(getValues("eliteSalesCommissionRate")) ||
        0;

      // Tỉ lệ PDV CVKD Elite
      const rateEliteData =
        Number(saleOpeningEventMechanismParameters?.statusKRate) === 2
          ? saleOpeningEventMechanismParameters?.rateElite
          : kRateCalc * rateEliteDefaultData >= 0
            ? kRateCalc * rateEliteDefaultData
            : 0;

      // Tỉ lệ TN MSH — khớp với calculateSummaryOnly:
      //   NOT_INCLUDED_ELITE: thuongNong = CVKD.mechanismRateElite - hoaHong          (KHÔNG trừ elite)
      //   INCLUDED_ELITE:     thuongNong = CVKD.mechanismRateElite - hoaHong - elite
      const rateTNData =
        Number(saleOpeningEventMechanismParameters?.statusKRate) === 2
          ? saleOpeningEventMechanismParameters?.rateTN || 0
          : cvkdRateMode === "NOT_INCLUDED_ELITE"
            ? Math.max(mechanismRateEliteCVKD - rateData, 0)
            : Math.max(mechanismRateEliteCVKD - rateData - rateEliteData, 0);

      dataKRate.incomeRate = rateTNData;

      // Tỉ lệ TN sàn
      const rateTNSanData = locking?.apartment?.rateTNSan || 0;

      dataKRate.platformIncomeRate =
        rateTNSanData || Number(getValues("platformIncomeRate")) || 0;

      // giá sàn
      const priceTNSanData = locking?.apartment?.priceTNSan || 0;
      dataKRate.priceTNSan =
        priceTNSanData || Number(getValues("priceTNSan")) || 0;

      if (Number(saleOpeningEventMechanismParameters?.statusKRate) === 2) {
        setValue("kRate", dataKRate.kRate);
        setValue("incomeRate", dataKRate.incomeRate);
        setValue("salesCommissionRate", rateData);
        setValue("eliteSalesCommissionRate", rateEliteData);
        setValue("platformIncomeRate", dataKRate.platformIncomeRate);
      } else {
        setValue("kRate", dataKRate.kRate);
        setValue("incomeRate", dataKRate.incomeRate);
        setValue("salesCommissionRate", dataKRate.salesCommissionRate);
        setValue(
          "eliteSalesCommissionRate",
          dataKRate.eliteSalesCommissionRate,
        );

        setValue("platformIncomeRate", dataKRate.platformIncomeRate);
      }
      setMechanismParameters({ ...dataKRate });
      // kết thúc tính toán kRate và các tỉ lệ
    }
  };

  const fectchDataSaleOpeningEventMechanismParameters = async (
    idSaleOpenEvent,
  ) => {
    try {
      const data =
        await saleOpeningEventMechanismParametersCall.listBySaleOpeningEvent(
          idSaleOpenEvent,
        );

      if (data) {
        const dataFilter = data?.map((item) => ({
          value: item?._id,
          label: item?.kRate,
        }));
        setDataKRate(dataFilter);

        if (data?.length === 1) {
          setValue("saleOpeningEventMechanismParametersId", data[0]?._id || "");
        }
      }
    } catch (error) {
      console.log("Lỗi khi fectch dữ liệu quản lý hệ số k");
    }
  };

  const fectchDataPeriodCompensation = async (id, idSaleOpenEvent, period) => {
    try {
      const data = await lockingCall.getPeriodFeeCompensation(
        id,
        idSaleOpenEvent,
        period,
      );

      setPeriodCompensation(data?.items || []);
    } catch (error) {
      console.log("Lỗi khi fectch dữ liệu quản lý hệ số k");
    }
  };

  useEffect(() => {
    if (lockingId && locking && step) {
      getFormData(lockingId, step.period, locking);
    }

    if (locking?.saleOpeningEventId) {
      fectchDataSaleOpeningEventMechanismParameters(
        locking?.saleOpeningEventId,
      );
    }
  }, [lockingId, locking, step]);

  const saleOpeningEventMechanismParametersId = watch(
    "saleOpeningEventMechanismParametersId",
  );

  useEffect(() => {
    if (saleOpeningEventMechanismParametersId) {
      getMechanism(saleOpeningEventMechanismParametersId);

      fectchDataPeriodCompensation(
        lockingId,
        saleOpeningEventMechanismParametersId,
        step.period,
      );
    }
  }, [saleOpeningEventMechanismParametersId]);

  const [zIndex, setZIndex] = useState("");
  const [focusStates, setFocusStates] = useState({});
  const [issCalculate, setIsCalculate] = useState(false);
  const [isCalculateFinalServiceFee, setIsCalculateFinalServiceFee] =
    useState(false); // Tính phí dịch vụ cuối cùng
  const [isConfirmCommissionStatus, setIsConfirmCommissionStatus] =
    useState(false); // đã ấn xác nhận
  const handleFocus = (field, data) => {
    if (data) {
      setZIndex(data);
    }
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };
  const handleBlur = (field, data) => {
    setZIndex("");
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };
  const handleDateChange = (selectedDate, inputName) => {
    setValue(inputName, selectedDate, { shouldValidate: true });
  };

  const [displayPrice, setDisplayPrice] = useState(0);
  const onChangePrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayPrice(formatPriceUS(numericValue));
      setValue("priceForCommission", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS],
  );
  const [displayPriceTN, setDisplayPriceTN] = useState(0);
  const onChangePriceTN = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayPriceTN(formatPriceUS(numericValue));
      setValue("priceTNSan", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS],
  );

  const [displayReferralPrice, setDisplayReferralPrice] = useState(0);
  const onChangeReferralPrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayReferralPrice(formatPriceUS(numericValue));
      setValue("displayReferralPrice", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS],
  );

  // tính toán lại
  const submit = (data) => {
    const dataEdit = {
      confirmCommissionStatus: ConfirmCommissionStatus.APPROVED,
    };

    if (mechanismParameters?.kRate || data?.kRate) {
      dataEdit.kRate = mechanismParameters?.kRate || data?.kRate;
    }

    if (data?.priceForCommission) {
      dataEdit.priceForCommission = data?.priceForCommission;
    }

    // Đợt
    if (data?.period) {
      dataEdit.period = data?.period;
    }

    if (data?.calculateCommissionRate) {
      dataEdit.calculateCommissionRate = data?.calculateCommissionRate;
    }
    //

    if (data?.transactionRate) {
      dataEdit.transactionRate = data?.transactionRate;
    }

    if (data?.standardWorkingDaysInMonth) {
      dataEdit.standardWorkingDaysInMonth = data?.standardWorkingDaysInMonth;
    }

    if (mechanismParameters?.incomeRate || data?.incomeRate) {
      dataEdit.incomeRate = mechanismParameters?.incomeRate || data?.incomeRate;
    }

    if (mechanismParameters?.platformIncomeRate || data?.platformIncomeRate) {
      dataEdit.platformIncomeRate =
        mechanismParameters?.platformIncomeRate || data?.platformIncomeRate;
    }

    if (mechanismParameters?.salesCommissionRate || data?.salesCommissionRate) {
      dataEdit.salesCommissionRate =
        mechanismParameters?.salesCommissionRate || data?.salesCommissionRate;
    }

    if (
      mechanismParameters?.eliteSalesCommissionRate ||
      data?.eliteSalesCommissionRate
    ) {
      dataEdit.eliteSalesCommissionRate =
        mechanismParameters?.eliteSalesCommissionRate ||
        data?.eliteSalesCommissionRate;
    }

    if (stepHandleRate.includes("incomeRate")) {
      dataEdit.incomeRate = getValues("incomeRate");
    }

    if (stepHandleRate.includes("platformIncomeRate")) {
      dataEdit.platformIncomeRate = getValues("platformIncomeRate");
    }

    if (stepHandleRate.includes("priceTNSan")) {
      mechanismParameters.priceTNSan = getValues("priceTNSan");
    }

    if (stepHandleRate.includes("salesCommissionRate")) {
      dataEdit.salesCommissionRate = getValues("salesCommissionRate");
    }

    if (stepHandleRate.includes("eliteSalesCommissionRate")) {
      dataEdit.eliteSalesCommissionRate = getValues("eliteSalesCommissionRate");
    }

    // console.log({ lockingId, dataEdit });

    const {
      kRate,
      calculateCommissionRate,
      priceForCommission,
      standardWorkingDaysInMonth,
      transactionRate,
      incomeRate,
      platformIncomeRate,
      salesCommissionRate,
      eliteSalesCommissionRate,
      //
      displayReferralPrice,
      commissionRateBlockManagerDH,
      commissionRateBlockManagerDT,
      commissionRateBlockManagerCL,
      commissionRateAreaManagerDH,
      commissionRateAreaManagerDT,
      commissionRateAreaManagerCL,
      commissionRateGeneralDirector,
    } = data;

    handleCaculate(
      Number(dataEdit?.kRate || kRate),
      Number(dataEdit?.calculateCommissionRate || calculateCommissionRate),
      Number(dataEdit?.priceForCommission || priceForCommission),
      Number(
        dataEdit?.standardWorkingDaysInMonth || standardWorkingDaysInMonth,
      ),
      Number(dataEdit?.transactionRate || transactionRate),
      Number(dataEdit?.incomeRate || incomeRate),
      Number(dataEdit?.platformIncomeRate || platformIncomeRate),
      Number(dataEdit?.salesCommissionRate || salesCommissionRate),
      Number(dataEdit?.eliteSalesCommissionRate || eliteSalesCommissionRate),
      Number(mechanismParameters?.priceTNSan || 0),
      //
      Number(displayReferralPrice),
      (Number(commissionRateBlockManagerDH) *
        Number(dataEdit?.transactionRate || transactionRate)) /
        100,
      (Number(commissionRateBlockManagerDT) *
        Number(dataEdit?.transactionRate || transactionRate)) /
        100,
      (Number(commissionRateBlockManagerCL) *
        Number(dataEdit?.transactionRate || transactionRate)) /
        100,
      (Number(commissionRateAreaManagerDH) *
        Number(dataEdit?.transactionRate || transactionRate)) /
        100,
      (Number(commissionRateAreaManagerDT) *
        Number(dataEdit?.transactionRate || transactionRate)) /
        100,
      (Number(commissionRateAreaManagerCL) *
        Number(dataEdit?.transactionRate || transactionRate)) /
        100,
      (Number(commissionRateGeneralDirector) *
        Number(dataEdit?.transactionRate || transactionRate)) /
        100,
    );
  };

  const submitHandler = (data) => {
    submit(data);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingCalculateFinal, setIsLoadingCalculateFinal] = useState(false);

  const handleReset = async () => {
    setIsCalculate(false);
    await getFormData(lockingId, step.period, locking);
  };

  // ===== Helpers calc totals (PURE) =====
  const safeNum = (v) =>
    Number.isFinite(Number(v)) ? Number(roundNumber(v)) : 0;

  // NV tham gia: tổng TN = incomePrice + platformIncomePrice
  // tổng PDV = salesCommissionPrice + eliteSalesCommissionPrice
  const calcTotalRelativeParticipant = (list = []) => {
    return list.reduce(
      (acc, curr) => {
        // ── Decimal: cộng dồn tránh sai số float ──
        acc.totalIncome = D(acc.totalIncome)
          .plus(D(safeNum(curr.incomePrice)))
          .plus(D(safeNum(curr.platformIncomePrice)))
          .toNumber();
        acc.totalCommission = D(acc.totalCommission)
          .plus(D(safeNum(curr.salesCommissionPrice)))
          .plus(D(safeNum(curr.eliteSalesCommissionPrice)))
          .toNumber();
        return acc;
      },
      { totalIncome: 0, totalCommission: 0 },
    );
  };

  // Block/Vùng: dữ liệu dạng
  const calcTotalManagerBlocks = (blocks = []) => {
    return blocks.reduce(
      (acc, block) => {
        // commissionRate đã là tỉ lệ hiệu dụng (đã gồm mainSellerRate) nên cộng thẳng
        (block?.items || []).forEach((item) => {
          // ── Decimal: cộng dồn tránh sai số float ──
          acc.totalRate = D(acc.totalRate)
            .plus(D(safeNum(item.commissionRate)))
            .toNumber();
          acc.totalPrice = D(acc.totalPrice)
            .plus(D(safeNum(item.commissionPrice)))
            .toNumber();
        });
        return acc;
      },
      { totalRate: 0, totalPrice: 0 },
    );
  };

  // Referrals
  const calcTotalReferrals = (list = []) => {
    return list.reduce(
      (acc, item) => {
        // ── Decimal: cộng dồn tránh sai số float ──
        acc.totalPrice = D(acc.totalPrice)
          .plus(D(safeNum(item.commissionPrice)))
          .toNumber();
        return acc;
      },
      { totalRate: 0, totalPrice: 0 },
    );
  };

  // Managers (TGD)
  const calcTotalManagers = (list = []) => {
    return list.reduce(
      (acc, item) => {
        // Nhân mainSellerRate để tính đúng tỉ lệ khi có nhiều sale chính (vd 2 sale 50%/50%)
        const mainSellerRate =
          Number(
            item?.mainSellerCommissionRate || item?.mainSellerRate || 100,
          ) / 100;
        // ── Decimal: cộng dồn tránh sai số float ──
        acc.totalRate = D(acc.totalRate)
          .plus(D(safeNum(item.commissionRate)).mul(D(mainSellerRate)))
          .toNumber();
        acc.totalPrice = D(acc.totalPrice)
          .plus(D(safeNum(item.commissionPrice)))
          .toNumber();
        return acc;
      },
      { totalRate: 0, totalPrice: 0 },
    );
  };

  // Tổng tất cả PDV
  const calcTotalAllCommissionPrice = ({
    relativeTotals,
    saleBlockTotals,
    saleAreaTotals,
    referralTotals,
    managerTotals,
  }) => {
    // ── Decimal: cộng tổng tránh sai số float ──
    return D(safeNum(relativeTotals.totalIncome))
      .plus(D(safeNum(relativeTotals.totalCommission)))
      .plus(D(safeNum(saleBlockTotals.totalPrice)))
      .plus(D(safeNum(saleAreaTotals.totalPrice)))
      .plus(D(safeNum(referralTotals.totalPrice)))
      .plus(D(safeNum(managerTotals.totalPrice)))
      .toNumber();
  };

  const applyTotalsToForm = ({
    relativeTotals,
    saleBlockTotals,
    saleAreaTotals,
    referralTotals,
    managerTotals,
    totalAllCommissionRate,
    totalAllCommissionPrice,
  }) => {
    // NV
    setTotalRelativeParticipantIncomePrice(
      formatPriceUS(relativeTotals.totalIncome),
    );
    setValue(
      "totalRelativeParticipantIncomePrice",
      safeNum(relativeTotals.totalIncome),
      { shouldValidate: true },
    );

    setTotalRelativeParticipantCommission(
      formatPriceUS(relativeTotals.totalCommission),
    );
    setValue(
      "totalRelativeParticipantCommission",
      safeNum(relativeTotals.totalCommission),
      { shouldValidate: true },
    );

    // GDK
    setValue(
      "totalSaleBlockManagerCommissionRate",
      safeNum(saleBlockTotals.totalRate),
      { shouldValidate: true },
    );

    setTotalSaleBlockManagerCommissionPrice(
      formatPriceUS(saleBlockTotals.totalPrice),
    );
    setValue(
      "totalSaleBlockManagerCommissionPrice",
      safeNum(saleBlockTotals.totalPrice),
      { shouldValidate: true },
    );

    // GDV
    setValue(
      "totalSaleAreaManagerCommissionRate",
      safeNum(saleAreaTotals.totalRate),
      { shouldValidate: true },
    );

    setTotalSaleAreaManagerCommissionPrice(
      formatPriceUS(saleAreaTotals.totalPrice),
    );
    setValue(
      "totalSaleAreaManagerCommissionPrice",
      safeNum(saleAreaTotals.totalPrice),
      { shouldValidate: true },
    );

    // Referral
    setValue("totalReferralsCommissionRate", 0, { shouldValidate: true });

    setTotalReferralsCommissionPrice(formatPriceUS(referralTotals.totalPrice));
    setValue(
      "totalReferralsCommissionPrice",
      safeNum(referralTotals.totalPrice),
      { shouldValidate: true },
    );

    // Tổng tất cả
    setValue(
      "totalAllCommissionRate",
      Number(roundNumber(totalAllCommissionRate)),
      { shouldValidate: true },
    );

    setTotalAllCommissionPrice(formatPriceUS(totalAllCommissionPrice));
    setValue("totalAllCommissionPrice", safeNum(totalAllCommissionPrice), {
      shouldValidate: true,
    });
  };

  const hydrateCertificateForFinalEmployees = async (list = []) => {
    try {
      const employeeIds = [
        ...new Set(list.map((x) => x?.employeeId).filter(Boolean)),
      ];

      if (employeeIds.length === 0) return list;

      const data = await attendanceCall.getCertificateByEmployeeIds(
        lockingId,
        employeeIds,
      );

      const certList = Array.isArray(data) ? data : [];

      const certMap = new Map();
      for (const c of certList) {
        const eId = c?.employeeId || c?.employeeObject?._id;
        if (!eId) continue;

        certMap.set(eId, {
          amountHeld: safeNum(c?.amountHeld),
          amountOldCertificate: safeNum(c?.amountOldCertificate),
        });
      }

      return list.map((emp) => {
        const cert = certMap.get(emp.employeeId);

        return {
          ...emp,
          amountHeld: cert?.amountHeld ?? safeNum(emp?.amountHeld),
          amountOldCertificate:
            cert?.amountOldCertificate ?? safeNum(emp?.amountOldCertificate),
        };
      });
    } catch (e) {
      console.log("hydrateCertificateForFinalEmployees error:", e);
      return list; // fallback không crash flow
    }
  };

  const handleCaculate = async (
    kRate, // hệ số k
    calculateCommissionRate, // TTDA
    priceForCommission, // Giá tính PDV
    standardWorkingDaysInMonth, // NCC
    transactionRate, // Tỉ lệ giao dịch
    incomeRate, // Tỉ lệ TN MSH
    platformIncomeRate, // Tỉ lệ TN sàn
    salesCommissionRate, // Tỉ lệ CVKD
    eliteSalesCommissionRate, // Tỉ lệ CVKD elite
    priceTNSan, // Số tiền TN sàn
    //
    displayReferralPrice,
    commissionRateBlockManagerDH,
    commissionRateBlockManagerDT,
    commissionRateBlockManagerCL,
    commissionRateAreaManagerDH,
    commissionRateAreaManagerDT,
    commissionRateAreaManagerCL,
    commissionRateGeneralDirector,
  ) => {
    console.log({
      kRate, // hệ số k
      calculateCommissionRate, // TTDA
      priceForCommission, // Giá tính PDV
      standardWorkingDaysInMonth, // NCC
      transactionRate, // Tỉ lệ giao dịch
      incomeRate, // Tỉ lệ TN MSH
      platformIncomeRate, // Tỉ lệ TN sàn
      salesCommissionRate, // Tỉ lệ CVKD
      eliteSalesCommissionRate, // Tỉ lệ CVKD elite
      priceTNSan,
    });

    setIsLoading(true);
    setStepHandle(2);
    // init
    // let totalAllCommissionRate =
    //   ((incomeRate || 0) +
    //     (platformIncomeRate || 0) +
    //     (salesCommissionRate || 0) +
    //     (eliteSalesCommissionRate || 0)) *
    //   (calculateCommissionRate / 100);
    // let totalAllCommissionPrice = 0;

    // Nhân viên tham gia
    let totalRelativeParticipantIncomePrice = 0;
    let totalRelativeParticipantCommissionPrice = 0;

    // Giám đốc khối tham gia
    let totalSaleBlockManagerCommissionRate = 0;
    let totalSaleBlockManagerCommissionPrice = 0;

    // Giám đốc vùng tham gia
    let totalSaleAreaManagerCommissionRate = 0;
    let totalSaleAreaManagerCommissionPrice = 0;

    // Người giới thiệu tham gia
    let totalReferralsCommissionRate = 0;
    let totalReferralsCommissionPrice = 0;

    // Giam đốc
    let totalManagerCommissionRate = 0;
    let totalManagerCommissionPrice = 0;

    let relativeTotals = 0;
    let saleBlockTotals = 0;
    let saleAreaTotals = 0;
    let referralTotals = 0;
    let managerTotals = 0;

    const finalEmployeeList = [];

    // Danh sách người tham gia sau tính toán
    if (relativeParticipant?.length > 0) {
      const lockingRelativeParticipantList = relativeParticipant.map((item) => {
        // ── Decimal: tính giá cho NV tham gia ──────────────────────────────
        const _commRate = D(item?.commissionRate ?? 0).div(100);

        const incomePrice = D(calculateCommissionRate)
          .div(100) // TTDA
          .mul(D(transactionRate).div(100)) // Tỉ lệ GD
          .mul(D(incomeRate).div(100)) // Tỉ lệ TN
          .mul(_commRate) // Tỉ lệ
          .mul(D(priceForCommission)) // Giá tính PDV
          .toNumber();

        const platformIncomePrice = D(calculateCommissionRate)
          .div(100) // TTDA
          .mul(D(transactionRate).div(100)) // Tỉ lệ GD
          .mul(D(platformIncomeRate).div(100)) // Tỉ lệ TN sàn
          .mul(_commRate) // Tỉ lệ
          .mul(D(priceForCommission)) // Giá tính PDV
          .plus(D(priceTNSan).mul(_commRate)) // + priceTNSan * tỉ lệ
          .toNumber();

        const salesCommissionPrice = D(kRate) // Hệ số K
          .mul(D(calculateCommissionRate).div(100)) // TTDA
          .mul(D(transactionRate).div(100)) // Tỉ lệ GD
          .mul(D(salesCommissionRate).div(100)) // Tỉ lệ PDV CVKD
          .mul(_commRate) // Tỉ lệ
          .mul(D(priceForCommission)) // Giá tính PDV
          .toNumber();

        // CTV dùng cờ Elite theo người bán chính (NBC) của họ, không theo bản thân,
        // để công thức Elite đồng nhất trong 1 người bán chính.
        const mainSellerOfItem =
          item?.isCollaborator && item?.mainSellerId
            ? relativeParticipant.find(
                (p) =>
                  !p?.isCollaborator &&
                  String(p?.employeeId) === String(item?.mainSellerId),
              )
            : null;
        // Coi là Elite khi cờ isElite = true (đồng bộ từ chấm công) HOẶC dòng vốn
        // đã có Số tiền PDV CVKD Elite > 0 (đã được tính Elite trước đó). Nhờ vậy
        // bấm "Tính toán" không làm mất (ghi về 0) giá trị Elite đã có, mà tính
        // lại theo công thức cũ. CTV theo NBC, khớp với logic FE ở step3EmployeeForm.
        const effectiveIsElite = mainSellerOfItem
          ? mainSellerOfItem?.isElite === true ||
            Number(mainSellerOfItem?.eliteSalesCommissionPrice || 0) > 0
          : item?.isElite === true ||
            Number(item?.eliteSalesCommissionPrice || 0) > 0;

        let eliteSalesCommissionPrice = 0;
        if (effectiveIsElite) {
          eliteSalesCommissionPrice = D(kRate) // Hệ số K
            .mul(D(calculateCommissionRate).div(100)) // TTDA
            .mul(D(transactionRate).div(100)) // Tỉ lệ GD
            .mul(D(eliteSalesCommissionRate).div(100)) // Tỉ lệ CVKD Elite
            .mul(_commRate) // Tỉ lệ
            .mul(
              safeDivD(D(item?.workingDays || 0), standardWorkingDaysInMonth),
            ) // Tỉ công
            .mul(D(priceForCommission)) // Giá tính PDV
            .toNumber();
        }
        // ────────────────────────────────────────────────────────────────────

        const commissionPrice = D(incomePrice)
          .plus(D(platformIncomePrice))
          .plus(D(salesCommissionPrice))
          .plus(D(eliteSalesCommissionPrice))
          .toNumber();

        const newItem = {
          ...item,
          incomePrice: incomePrice || 0,
          platformIncomePrice: platformIncomePrice || 0,
          salesCommissionPrice: salesCommissionPrice || 0,
          eliteSalesCommissionPrice: eliteSalesCommissionPrice || 0,
          commissionPrice,
          //
          kRate,
          calculateCommissionRate,
          transactionRate,
          incomeRate,
          platformIncomeRate,
          salesCommissionRate,
          eliteSalesCommissionRate,
          standardWorkingDaysInMonth,
          priceForCommission,
          priceTNSan,
        };
        return newItem;
      });

      setRelativeParticipant(lockingRelativeParticipantList);
      finalEmployeeList.push(...lockingRelativeParticipantList);

      // // Tính tổng
      // if (lockingRelativeParticipantList?.length > 0) {
      //   const totals = lockingRelativeParticipantList.reduce(
      //     (acc, curr) => {
      //       acc.totalIncomePrice += curr.incomePrice || 0;
      //       acc.totalPlatformIncomePrice += curr.platformIncomePrice || 0;
      //       acc.totalSalesCommissionPrice += curr.salesCommissionPrice || 0;
      //       acc.totalEliteSalesCommissionPrice +=
      //         curr.eliteSalesCommissionPrice || 0;
      //       return acc;
      //     },
      //     {
      //       totalIncomePrice: 0,
      //       totalPlatformIncomePrice: 0,
      //       totalSalesCommissionPrice: 0,
      //       totalEliteSalesCommissionPrice: 0,
      //     },
      //   );

      //   // gán tổng
      //   totalRelativeParticipantIncomePrice =
      //     totals.totalIncomePrice + totals.totalPlatformIncomePrice;
      //   totalRelativeParticipantCommissionPrice =
      //     totals.totalSalesCommissionPrice +
      //     totals.totalEliteSalesCommissionPrice;

      //   // set State
      //   setTotalRelativeParticipantIncomePrice(
      //     formatPriceUS(totalRelativeParticipantIncomePrice),
      //   );
      //   setValue(
      //     "totalRelativeParticipantIncomePrice",
      //     Number(totalRelativeParticipantIncomePrice),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      //   setTotalRelativeParticipantCommission(
      //     formatPriceUS(totalRelativeParticipantCommissionPrice),
      //   );
      //   setValue(
      //     "totalRelativeParticipantCommission",
      //     Number(totalRelativeParticipantCommissionPrice),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      // }

      relativeTotals = calcTotalRelativeParticipant(
        lockingRelativeParticipantList || [],
      );
    }

    // Danh sách giám đốc khối tham gia tính toán
    if (saleBlockManagers?.length > 0) {
      const saleBlockManagersList = saleBlockManagers.map((block) => {
        const mainSellerRate = Number(
          block?.mainSellerCommissionRate || block?.commissionRate || 100,
        );
        const updatedItems = block.items.map((item) => {
          const interpretationRateMap = {
            GDKDH: commissionRateBlockManagerDH,
            GDKDT: commissionRateBlockManagerDT,
            GDKCL: commissionRateBlockManagerCL,
          };

          // Tỉ lệ mặc định đã gồm phần người bán chính (tỉ lệ hiệu dụng).
          // Item đã load từ DB thì commissionRate đã là hiệu dụng nên giữ nguyên.
          const defaultRate = D(
            interpretationRateMap[item?.interpretation] ?? 0.1,
          )
            .mul(D(mainSellerRate).div(100))
            .toNumber();

          const rate = item?.isFake
            ? defaultRate
            : item?.commissionRate || defaultRate;

          item.commissionRate = rate;

          const workingDayRate = item?.workingDays / standardWorkingDaysInMonth;

          // ── Decimal: tính commissionPrice GDK (commissionRate đã hiệu dụng) ──
          const commissionPrice = D(kRate)
            .mul(D(calculateCommissionRate).div(100))
            .mul(D(rate).div(100))
            .mul(D(workingDayRate))
            // .mul(D(transactionRate).div(100)) // Tỉ lệ GD
            .mul(D(priceForCommission))
            .toNumber();
          // ────────────────────────────────────────────────────────────────

          return {
            ...item,
            commissionPrice,
            mainSellerRate,
            commissionRate: rate,
            //
            kRate,
            calculateCommissionRate,
            transactionRate,
            standardWorkingDaysInMonth,
            priceForCommission,
            commissionRateBlockManagerDH,
            commissionRateBlockManagerDT,
            commissionRateBlockManagerCL,
          };
        });
        finalEmployeeList.push(...updatedItems);

        return {
          ...block,
          items: updatedItems,
        };
      });

      setSaleBlockManagers(saleBlockManagersList);

      // // Tính tổng
      // if (saleBlockManagersList?.length > 0) {
      //   const totals = saleBlockManagersList.reduce(
      //     (acc, block) => {
      //       block.items.forEach((item) => {
      //         acc.totalCommissionRate += item.commissionRate || 0;
      //         acc.totalCommissionPrice += item.commissionPrice || 0;
      //       });
      //       return acc;
      //     },
      //     {
      //       totalCommissionRate: 0,
      //       totalCommissionPrice: 0,
      //     },
      //   );

      //   // gán tổng
      //   totalSaleBlockManagerCommissionRate = totals.totalCommissionRate;
      //   totalSaleBlockManagerCommissionPrice = totals.totalCommissionPrice;
      //   // set State
      //   setValue(
      //     "totalSaleBlockManagerCommissionRate",
      //     Number(totalSaleBlockManagerCommissionRate),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      //   setTotalSaleBlockManagerCommissionPrice(
      //     formatPriceUS(totalSaleBlockManagerCommissionPrice),
      //   );
      //   setValue(
      //     "totalSaleBlockManagerCommissionPrice",
      //     Number(totalSaleBlockManagerCommissionPrice),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      // }

      saleBlockTotals = calcTotalManagerBlocks(saleBlockManagersList || []);
    }

    // Danh sách giám đốc vùng tham gia tính toán
    if (saleAreaManagers?.length > 0) {
      const saleAreaManagersList = saleAreaManagers.map((block) => {
        const mainSellerRate = Number(
          block?.mainSellerCommissionRate || block?.commissionRate || 100,
        );
        const updatedItems = block.items.map((item) => {
          const interpretationRateMap = {
            GDVDH: commissionRateAreaManagerDH,
            GDVDT: commissionRateAreaManagerDT,
            GDVCL: commissionRateAreaManagerCL,
          };

          // Tỉ lệ mặc định đã gồm phần người bán chính (tỉ lệ hiệu dụng).
          // Item đã load từ DB thì commissionRate đã là hiệu dụng nên giữ nguyên.
          const defaultRate = D(
            interpretationRateMap[item?.interpretation] ?? 0.06,
          )
            .mul(D(mainSellerRate).div(100))
            .toNumber();

          const rate = item?.isFake
            ? defaultRate
            : item?.commissionRate || defaultRate;

          item.commissionRate = rate;

          const workingDayRate = item?.workingDays / standardWorkingDaysInMonth;

          // ── Decimal: tính commissionPrice GDV (commissionRate đã hiệu dụng) ──
          const commissionPrice = D(kRate)
            .mul(D(calculateCommissionRate).div(100))
            .mul(D(rate).div(100))
            .mul(D(workingDayRate))
            // .mul(D(transactionRate).div(100)) // Tỉ lệ GD
            .mul(D(priceForCommission))
            .toNumber();
          // ────────────────────────────────────────────────────────────────

          return {
            ...item,
            commissionPrice,
            mainSellerRate,
            commissionRate: rate,
            //
            kRate,
            calculateCommissionRate,
            transactionRate,
            standardWorkingDaysInMonth,
            priceForCommission,
            commissionRateAreaManagerDH,
            commissionRateAreaManagerDT,
            commissionRateAreaManagerCL,
          };
        });
        finalEmployeeList.push(...updatedItems);

        return {
          ...block,
          items: updatedItems,
        };
      });

      setSaleAreaManagers(saleAreaManagersList);

      // // Tính tổng
      // if (saleAreaManagersList?.length > 0) {
      //   const totals = saleAreaManagersList.reduce(
      //     (acc, block) => {
      //       block.items.forEach((item) => {
      //         acc.totalCommissionRate += item.commissionRate || 0;
      //         acc.totalCommissionPrice += item.commissionPrice || 0;
      //       });
      //       return acc;
      //     },
      //     {
      //       totalCommissionRate: 0,
      //       totalCommissionPrice: 0,
      //     },
      //   );

      //   // gán tổng
      //   totalSaleAreaManagerCommissionRate = totals.totalCommissionRate;
      //   totalSaleAreaManagerCommissionPrice = totals.totalCommissionPrice;
      //   // set State
      //   setValue(
      //     "totalSaleAreaManagerCommissionRate",
      //     Number(totalSaleAreaManagerCommissionRate),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      //   setTotalSaleAreaManagerCommissionPrice(
      //     formatPriceUS(totalSaleAreaManagerCommissionPrice),
      //   );
      //   setValue(
      //     "totalSaleAreaManagerCommissionPrice",
      //     Number(totalSaleAreaManagerCommissionPrice),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      // }

      saleAreaTotals = calcTotalManagerBlocks(saleAreaManagersList || []);
    }

    // Danh sách người giới thiệu tham gia tính toán
    if (referrals?.length > 0) {
      const referralsList = referrals.map((item) => {
        // item.commissionRate = rate;

        const workingDayRate =
          Number(item?.workingDays || 0) / (standardWorkingDaysInMonth || 1);

        // const commissionPrice =
        //   kRate *
        //   (calculateCommissionRate / 100) *
        //   (rate / 100) *
        //   workingDayRate *
        //   priceForCommission;

        const price = checkedSwitch
          ? displayReferralPrice
          : item?.commissionPrice;
        // ── Decimal: tính commissionPrice người giới thiệu ────────────────
        const _rateD = D(calculateCommissionRate || 100).div(100);
        const _commPriceD = checkedSwitch
          ? _rateD.mul(D(price)).mul(D(workingDayRate))
          : D(price);
        const finalCommissionPrice = _commPriceD
          .mul(D(transactionRate).div(100)) // Tỉ lệ GD
          .toNumber();
        // ────────────────────────────────────────────────────────────────────

        return {
          ...item,
          commissionPrice: finalCommissionPrice,
          //
          kRate,
          calculateCommissionRate,
          transactionRate,
          standardWorkingDaysInMonth,
          priceForCommission,
          displayReferralPrice,
        };
      });

      setReferrals(referralsList);
      finalEmployeeList.push(...referralsList);

      // // Tính tổng
      // if (referralsList?.length > 0) {
      //   const totals = referralsList.reduce(
      //     (acc, curr) => {
      //       acc.totalCommissionRate += curr.commissionRate || 0;
      //       acc.totalCommissionPrice += curr.commissionPrice || 0;
      //       return acc;
      //     },
      //     {
      //       totalCommissionRate: 0,
      //       totalCommissionPrice: 0,
      //     },
      //   );

      //   // gán tổng
      //   totalReferralsCommissionRate = 0;
      //   totalReferralsCommissionPrice = totals.totalCommissionPrice;
      //   // set State
      //   setValue(
      //     "totalReferralsCommissionRate",
      //     Number(totalReferralsCommissionRate),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      //   setTotalReferralsCommissionPrice(
      //     formatPriceUS(totalReferralsCommissionPrice),
      //   );
      //   setValue(
      //     "totalReferralsCommissionPrice",
      //     Number(totalReferralsCommissionPrice),
      //     {
      //       shouldValidate: true,
      //     },
      //   );
      // }

      referralTotals = calcTotalReferrals(referralsList || []);
    }

    // Danh sách giám đốc tham gia tính toán
    if (managers?.length > 0) {
      const managersList = managers.map((item) => {
        const rate = item?.commissionRate
          ? item.commissionRate
          : (commissionRateGeneralDirector ?? 0.2);
        item.commissionRate = rate;

        const mainSellerRate = Number(item?.mainSellerCommissionRate || 100);
        // ── Decimal: tính commissionPrice TGĐ ──────────────────────────
        const commissionPrice = D(kRate)
          .mul(D(calculateCommissionRate).div(100))
          .mul(D(rate).div(100))
          // .mul(D(transactionRate).div(100)) // Tỉ lệ GD
          .mul(D(priceForCommission))
          .mul(D(mainSellerRate).div(100))
          .toNumber();
        // ────────────────────────────────────────────────────────────────

        return {
          ...item,
          commissionPrice,
          mainSellerRate,
          //
          kRate,
          calculateCommissionRate,
          transactionRate,
          standardWorkingDaysInMonth,
          priceForCommission,
          commissionRateGeneralDirector,
        };
      });

      setManagers(managersList);
      finalEmployeeList.push(...managersList);

      // // Tính tổng
      // if (managersList?.length > 0) {
      //   const totals = managersList.reduce(
      //     (acc, curr) => {
      //       acc.totalCommissionRate += curr.commissionRate || 0;
      //       acc.totalCommissionPrice += curr.commissionPrice || 0;
      //       return acc;
      //     },
      //     {
      //       totalCommissionRate: 0,
      //       totalCommissionPrice: 0,
      //     },
      //   );

      //   // gán tổng
      //   totalManagerCommissionRate = totals.totalCommissionRate;
      //   totalManagerCommissionPrice = totals.totalCommissionPrice;
      // }

      managerTotals = calcTotalManagers(managersList || []);
    }

    // console.log("rate", {
    //   totalSaleBlockManagerCommissionRate,
    //   totalSaleAreaManagerCommissionRate,
    //   totalReferralsCommissionRate,
    //   totalManagerCommissionRate,
    // });

    // console.log("price", {
    //   totalSaleBlockManagerCommissionPrice,
    //   totalSaleAreaManagerCommissionPrice,
    //   totalReferralsCommissionPrice,
    //   totalManagerCommissionPrice,
    // });

    // if (relativeParticipant?.length > 0) {
    //   // Tổng tất cả
    //   totalAllCommissionRate +=
    //     (totalSaleBlockManagerCommissionRate +
    //       totalSaleAreaManagerCommissionRate +
    //       totalReferralsCommissionRate +
    //       totalManagerCommissionRate) *
    //     (calculateCommissionRate / 100);

    //   totalAllCommissionPrice +=
    //     totalRelativeParticipantIncomePrice +
    //     totalRelativeParticipantCommissionPrice +
    //     totalSaleBlockManagerCommissionPrice +
    //     totalSaleAreaManagerCommissionPrice +
    //     totalReferralsCommissionPrice +
    //     totalManagerCommissionPrice;

    //   setValue(
    //     "totalAllCommissionRate",
    //     Number(totalAllCommissionRate).toFixed(2),
    //     {
    //       shouldValidate: true,
    //     },
    //   );
    //   setTotalAllCommissionPrice(formatPriceUS(totalAllCommissionPrice));
    //   setValue("totalAllCommissionPrice", Number(totalAllCommissionPrice), {
    //     shouldValidate: true,
    //   });
    // }

    if (finalEmployeeList.length > 0) {
      const commissionUpdates = new Map();
      for (const item of finalEmployeeList) {
        const key = `${lockingId}_${step.period}_${item?.employeeId}`;
        const commissionPrice = item?.commissionPrice || 0;
        const amountHeld = item?.amountHeld || 0;
        const amountOldCertificate = item?.amountOldCertificate || 0;
        if (commissionUpdates.has(key)) {
          const existing = commissionUpdates.get(key);
          existing.commissionPrice += commissionPrice;
        } else {
          commissionUpdates.set(key, {
            ...item,
            lockingId,
            period: step.period,
            commissionPrice,
            amountHeld,
            amountOldCertificate,
          });
        }
      }

      // setFinalEmployees(Array.from(commissionUpdates.values()));

      const mergedFinal = Array.from(commissionUpdates.values());

      const hydratedFinal =
        await hydrateCertificateForFinalEmployees(mergedFinal);

      setFinalEmployees(hydratedFinal);
    }

    // Tính tổng
    // ====== CALC TOTALS ======
    // totalAllCommissionRate – Decimal để tránh sai số
    const _calcRatePart1 = D(safeNum(incomeRate))
      .plus(D(safeNum(platformIncomeRate)))
      .plus(D(safeNum(salesCommissionRate)))
      .plus(D(safeNum(eliteSalesCommissionRate)));
    // .mul(D(calculateCommissionRate).div(100));
    const _calcRatePart2 = D(safeNum(saleBlockTotals.totalRate))
      .plus(D(safeNum(saleAreaTotals.totalRate)))
      .plus(D(safeNum(referralTotals.totalRate)))
      .plus(D(safeNum(managerTotals.totalRate)));
    // .mul(D(calculateCommissionRate).div(100));
    const totalAllCommissionRate = _calcRatePart1
      .plus(_calcRatePart2)
      .toNumber();

    const totalAllCommissionPrice = calcTotalAllCommissionPrice({
      relativeTotals,
      saleBlockTotals,
      saleAreaTotals,
      referralTotals,
      managerTotals,
    });

    applyTotalsToForm({
      relativeTotals,
      saleBlockTotals,
      saleAreaTotals,
      referralTotals,
      managerTotals,
      totalAllCommissionRate,
      totalAllCommissionPrice,
    });

    // Show tính toán
    await delay(1000);
    setIsLoading(false);
    setIsCalculate(true);
    setIsCalculateFinalServiceFee(false);
    scrollToBottom();

    // console.log({ saleBlockManagers, saleAreaManagers, referrals, managers });
    // setApproveData(lockingRelativeParticipantdata);
  };

  // Lấy trạng thái CCMG hiện tại (Employee.isBrokerDebtCertificate) theo employeeId.
  // NV gọi lỗi / không có dữ liệu thì không có trong map → giữ cờ cũ trên item.
  const fetchLatestCcmgStatusMap = async (list = []) => {
    const employeeIds = [
      ...new Set(list.map((x) => x?.employeeId).filter(Boolean).map(String)),
    ];
    const entries = await Promise.all(
      employeeIds.map(async (id) => {
        try {
          const emp = await clientAPI("get", `/employee/${id}`);
          return typeof emp?.isBrokerDebtCertificate === "boolean"
            ? [id, emp.isBrokerDebtCertificate]
            : null;
        } catch {
          return null;
        }
      }),
    );
    return new Map(entries.filter(Boolean));
  };

  // tính toán phí dịch vụ cuối cùng
  const handleCaculateFinalEmployees = async () => {
    setIsLoadingCalculateFinal(true);
    const certificateOrDepositPercent = 0.3; //30%
    const personalIncomeTaxPercent = 0.1; //10%
    const certificateOrDepositMax = 30000000; //30 triệu
    if (finalEmployees.length > 0) {
      // item.isBrokerDebtCertificate là ảnh chụp lúc tính PDV lần trước (lưu trong
      // CalculateCommission). NV được cập nhật "đã có CCMG" sau đó thì cờ cũ vẫn = false
      // → CCMG bị tính lại 30%. Vì vậy phải lấy MỚI từ Employee trước khi tính.
      const latestCcmgMap = await fetchLatestCcmgStatusMap(finalEmployees);
      const finalEmployeesList = finalEmployees.map((item) => {
        const isBrokerDebtCertificate = latestCcmgMap.has(
          String(item?.employeeId),
        )
          ? latestCcmgMap.get(String(item?.employeeId))
          : item?.isBrokerDebtCertificate;
        const amountHeld = item?.amountHeld || 0;
        const amountOldCertificate = item?.amountOldCertificate || 0;
        const commissionPrice = item?.commissionPrice || 0;
        let personalIncomeTax = item?.personalIncomeTax || 0;

        console.log("handleCaculateFinalEmployees", {
          amountHeld,
          amountOldCertificate,
        });

        const serviceFee = {
          certificateOrDeposit: item?.certificateOrDeposit || 0, // Chứng chỉ/ký quỹ
          accountingFromPreviousPeriodOrAdvance:
            item?.accountingFromPreviousPeriodOrAdvance || 0, // KT do đã DC kỳ trước/Đã tạm ứng/KT khác
          remainingRevenueAfterAccounting:
            item?.remainingRevenueAfterAccounting || 0, // PDV còn lại sau KT
          personalIncomeTax: personalIncomeTax, // Thuế TNCN
          remainingRevenueAfterTax: item?.remainingRevenueAfterTax || 0, // PDV còn lại sau thuế
          bonus: item?.bonus || 0, // PDV còn lại sau thuế
          commissionAfterCertificateOrDeposit: 0,
        };

        // ── Decimal: tính phí dịch vụ cuối cùng ────────────────────────────
        const commissionAfterCertificateOrDeposit = D(commissionPrice)
          .plus(D(serviceFee.bonus))
          .toNumber();
        serviceFee.commissionAfterCertificateOrDeposit =
          commissionAfterCertificateOrDeposit;

        // GTDL (người giới thiệu) không bị tính CCMG và thuế TNCN
        const isGTDL =
          item?.type === "NGUOI_GIOI_THIEU_NGUOI_BAN_HANG_TRUC_TIEP" ||
          item?.items?.[0]?.type ===
            "NGUOI_GIOI_THIEU_NGUOI_BAN_HANG_TRUC_TIEP";

        // chưa có CCMG ( Số tiền tạm giữ )
        if (!isBrokerDebtCertificate && !isGTDL) {
          const certificateOrDepositRemaining = D(certificateOrDepositMax)
            .minus(D(amountHeld))
            .plus(D(amountOldCertificate))
            .toNumber(); // số tiền còn lại
          const certificateOrDeposit = D(commissionAfterCertificateOrDeposit)
            .mul(certificateOrDepositPercent)
            .toNumber(); // Chứng chỉ/ký quỹ theo phần trăm

          if (certificateOrDepositRemaining > certificateOrDeposit) {
            serviceFee.certificateOrDeposit =
              certificateOrDeposit > 0 ? certificateOrDeposit : 0;
          } else {
            serviceFee.certificateOrDeposit =
              certificateOrDepositRemaining > 0
                ? certificateOrDepositRemaining
                : 0;
          }
        } else if (isBrokerDebtCertificate && !isGTDL) {
          // đã có CCMG → không tạm giữ CCMG (khớp calcAutoCertificate ở Step3FinalServiceFeeForm)
          serviceFee.certificateOrDeposit = 0;
        }

        serviceFee.remainingRevenueAfterAccounting = D(
          commissionAfterCertificateOrDeposit,
        )
          .minus(
            D(serviceFee.certificateOrDeposit).plus(
              D(serviceFee.accountingFromPreviousPeriodOrAdvance),
            ),
          )
          .toNumber();
        // + serviceFee.bonus

        serviceFee.personalIncomeTax = D(
          serviceFee.remainingRevenueAfterAccounting,
        )
          .mul(personalIncomeTaxPercent)
          .toNumber();
        // ────────────────────────────────────────────────────────────────────

        // nếu là giám đốc hoặc GTDL thì tncn = 0
        if (
          item?.manager?.code === "CT01-15" ||
          item?.employeeObject?.code === "CT01-15"
          // || isGTDL // TẠM COMMENT: vẫn tính Thuế TNCN cho NGTDL (người giới thiệu)
        ) {
          serviceFee.personalIncomeTax = 0;
        }

        serviceFee.remainingRevenueAfterTax = D(
          serviceFee.remainingRevenueAfterAccounting,
        )
          .minus(D(serviceFee.personalIncomeTax))
          .toNumber();

        return {
          ...item,
          ...serviceFee,
          isBrokerDebtCertificate,
        };
      });

      // ── Decimal: cộng tổng phí dịch vụ cuối cùng ──────────────────────
      const totals = finalEmployeesList.reduce(
        (acc, curr) => {
          acc.commissionPrice = D(acc.commissionPrice)
            .plus(D(curr.commissionPrice || 0))
            .toNumber();
          acc.bonus = D(acc.bonus)
            .plus(D(curr.bonus || 0))
            .toNumber();
          acc.certificateOrDeposit = D(acc.certificateOrDeposit)
            .plus(D(curr.certificateOrDeposit || 0))
            .toNumber();
          acc.accountingFromPreviousPeriodOrAdvance = D(
            acc.accountingFromPreviousPeriodOrAdvance,
          )
            .plus(D(curr.accountingFromPreviousPeriodOrAdvance || 0))
            .toNumber();
          acc.remainingRevenueAfterAccounting = D(
            acc.remainingRevenueAfterAccounting,
          )
            .plus(D(curr.remainingRevenueAfterAccounting || 0))
            .toNumber();
          acc.personalIncomeTax = D(acc.personalIncomeTax)
            .plus(D(curr.personalIncomeTax || 0))
            .toNumber();
          acc.remainingRevenueAfterTax = D(acc.remainingRevenueAfterTax)
            .plus(D(curr.remainingRevenueAfterTax || 0))
            .toNumber();
          return acc;
        },
        {
          commissionPrice: 0,
          bonus: 0,
          certificateOrDeposit: 0,
          accountingFromPreviousPeriodOrAdvance: 0,
          remainingRevenueAfterAccounting: 0,
          personalIncomeTax: 0,
          remainingRevenueAfterTax: 0,
        },
      );
      // ────────────────────────────────────────────────────────────────────
      setTotalFinalServiceFee(totals);
      // console.log({ finalEmployees, totals });
      setFinalEmployees(finalEmployeesList);
    }
    // await delay(1000);
    setIsLoadingCalculateFinal(false);
    setIsCalculate(true);
    setIsCalculateFinalServiceFee(true);
    scrollToBottom();
  };

  // Tính tổng cộng khi sửa tính toán PDV cuối cùng
  const calcTotalPDV = (list) => {
    // ── Decimal: cộng dồn tránh sai số float ──────────────────────────────
    const totals = list.reduce(
      (acc, curr) => {
        acc.commissionPrice = D(acc.commissionPrice)
          .plus(D(curr.commissionPrice || 0))
          .toNumber();
        acc.bonus = D(acc.bonus)
          .plus(D(curr.bonus || 0))
          .toNumber();
        acc.certificateOrDeposit = D(acc.certificateOrDeposit)
          .plus(D(curr.certificateOrDeposit || 0))
          .toNumber();
        acc.accountingFromPreviousPeriodOrAdvance = D(
          acc.accountingFromPreviousPeriodOrAdvance,
        )
          .plus(D(curr.accountingFromPreviousPeriodOrAdvance || 0))
          .toNumber();
        acc.remainingRevenueAfterAccounting = D(
          acc.remainingRevenueAfterAccounting,
        )
          .plus(D(curr.remainingRevenueAfterAccounting || 0))
          .toNumber();
        acc.personalIncomeTax = D(acc.personalIncomeTax)
          .plus(D(curr.personalIncomeTax || 0))
          .toNumber();
        acc.remainingRevenueAfterTax = D(acc.remainingRevenueAfterTax)
          .plus(D(curr.remainingRevenueAfterTax || 0))
          .toNumber();
        return acc;
      },
      {
        commissionPrice: 0,
        bonus: 0,
        certificateOrDeposit: 0,
        accountingFromPreviousPeriodOrAdvance: 0,
        remainingRevenueAfterAccounting: 0,
        personalIncomeTax: 0,
        remainingRevenueAfterTax: 0,
      },
    );
    // ────────────────────────────────────────────────────────────────────────
    // setTotalFinalServiceFee(totals);
    return totals;
  };

  useEffect(() => {
    const total = calcTotalPDV(finalEmployees);
    total.remainingRevenueAfterTax =
      total.remainingRevenueAfterAccounting - total.personalIncomeTax;
    setTotalFinalServiceFee(total);
  }, [finalEmployees]);

  const handleEmployeeChange = useCallback((index, changes) => {
    setRelativeParticipant((list) =>
      list.map((item, i) => (i === index ? { ...item, ...changes } : item)),
    );
  }, []);

  const handleEmployeeRemoveRow = useCallback((idx) => {
    setRelativeParticipant((prev) => prev.filter((_, i) => i !== idx));
  }, []);

  const handleSaleBlockManagerChange = useCallback(
    (managerIndex, itemIndex, changes) => {
      setSaleBlockManagers((list) =>
        list.map((manager, i) => {
          if (i !== managerIndex) return manager;

          const updatedItems = manager.items.map((item, j) => {
            if (j === itemIndex) {
              return {
                ...item,
                ...changes,
              };
            }
            return item;
          });

          return {
            ...manager,
            items: updatedItems,
          };
        }),
      );
    },
    [],
  );

  const handleSaleBlockManagerRemoveRow = useCallback(
    (managerIndex, itemIndex) => {
      setSaleBlockManagers((list) =>
        list.map((manager, i) => {
          if (i !== managerIndex) return manager;

          const updatedItems = manager.items.filter((_, j) => j !== itemIndex);

          return {
            ...manager,
            items: updatedItems,
          };
        }),
      );
    },
    [],
  );

  const handleSaleAreaManagerChange = useCallback(
    (managerIndex, itemIndex, changes) => {
      setSaleAreaManagers((list) =>
        list.map((manager, i) => {
          if (i !== managerIndex) return manager;

          const updatedItems = manager.items.map((item, j) => {
            if (j === itemIndex) {
              return {
                ...item,
                ...changes,
              };
            }
            return item;
          });

          return {
            ...manager,
            items: updatedItems,
          };
        }),
      );
    },
    [],
  );

  const handleSaleAreaManagerRemoveRow = useCallback(
    (managerIndex, itemIndex) => {
      setSaleAreaManagers((list) =>
        list.map((manager, i) => {
          if (i !== managerIndex) return manager;

          const updatedItems = manager.items.filter((_, j) => j !== itemIndex);

          return {
            ...manager,
            items: updatedItems,
          };
        }),
      );
    },
    [],
  );

  const handleReferralsChange = useCallback((index, changes) => {
    setReferrals((list) =>
      list.map((item, i) => (i === index ? { ...item, ...changes } : item)),
    );
  }, []);

  const handleReferralsRemoveRow = useCallback((idx) => {
    setReferrals((prev) => prev.filter((_, i) => i !== idx));
  }, []);

  const handleManagerChange = useCallback((index, changes) => {
    setManagers((list) =>
      list.map((item, i) => (i === index ? { ...item, ...changes } : item)),
    );
  }, []);

  const handleManagerRemoveRow = useCallback((idx) => {
    setManagers((prev) => prev.filter((_, i) => i !== idx));
  }, []);

  const handleFinalEmployeesChange = useCallback((index, changes) => {
    setFinalEmployees((list) =>
      list.map((item, i) => (i === index ? { ...item, ...changes } : item)),
    );
  }, []);

  const handleFinalEmployeesRemoveRow = useCallback((idx) => {
    setFinalEmployees((prev) => prev.filter((_, i) => i !== idx));
  }, []);

  const onchangeSaleOpeningEventMechanismParametersId = (option) => {
    // check
    kRateChangedByUserRef.current = true;
    setKRateChangedByUser(true);

    setValue("saleOpeningEventMechanismParametersId", option);

    const found = dataKRate.find((item) => item.value === option);

    if (found?.label) {
      setValue("kRate", found?.label);
    }
  };

  // xác nhận
  const approveCommission = async (
    lockingId,
    status = ConfirmCommissionStatus.APPROVED,
  ) => {
    const toastCreate = toast.loading("Đang cập nhật trạng thái ...");
    const period = getValues("period");

    const kRate = getValues("kRate");
    const calculateCommissionRate = getValues("calculateCommissionRate");
    const saleOpeningEventMechanismParametersId = getValues(
      "saleOpeningEventMechanismParametersId",
    );
    const priceForCommission = getValues("priceForCommission");
    const standardWorkingDaysInMonth = getValues("standardWorkingDaysInMonth");
    const transactionRate = getValues("transactionRate");
    const incomeRate = getValues("incomeRate");
    const platformIncomeRate = getValues("platformIncomeRate");
    const salesCommissionRate = getValues("salesCommissionRate");
    const eliteSalesCommissionRate = getValues("eliteSalesCommissionRate");
    const priceTNSan = getValues("priceTNSan");
    const month = getValues("month");
    const year = getValues("year");

    // Tỉ lệ tính PDV
    const displayReferralPrice = getValues("displayReferralPrice");
    const commissionRateBlockManagerDH = getValues(
      "commissionRateBlockManagerDH",
    );
    const commissionRateBlockManagerDT = getValues(
      "commissionRateBlockManagerDT",
    );
    const commissionRateBlockManagerCL = getValues(
      "commissionRateBlockManagerCL",
    );
    const commissionRateAreaManagerDH = getValues(
      "commissionRateAreaManagerDH",
    );
    const commissionRateAreaManagerDT = getValues(
      "commissionRateAreaManagerDT",
    );
    const commissionRateAreaManagerCL = getValues(
      "commissionRateAreaManagerCL",
    );
    const commissionRateGeneralDirector = getValues(
      "commissionRateGeneralDirector",
    );

    // TOTAL
    const totalRelativeParticipantIncomePrice = Number(
      getValues("totalRelativeParticipantIncomePrice") || 0,
    );
    const totalRelativeParticipantCommissionPrice = Number(
      getValues("totalRelativeParticipantCommission") || 0,
    );

    const totalSaleBlockManagerCommissionRate = Number(
      getValues("totalSaleBlockManagerCommissionRate") || 0,
    );
    const totalSaleBlockManagerCommissionPrice = Number(
      getValues("totalSaleBlockManagerCommissionPrice") || 0,
    );

    const totalSaleAreaManagerCommissionRate = Number(
      getValues("totalSaleAreaManagerCommissionRate") || 0,
    );
    const totalSaleAreaManagerCommissionPrice = Number(
      getValues("totalSaleAreaManagerCommissionPrice") || 0,
    );

    const totalReferralsCommissionRate = Number(
      getValues("totalReferralsCommissionRate") || 0,
    );
    const totalReferralsCommissionPrice = Number(
      getValues("totalReferralsCommissionPrice") || 0,
    );

    const totalAllCommissionRate = Number(
      getValues("totalAllCommissionRate") || 0,
    );
    const totalAllCommissionPrice = Number(
      getValues("totalAllCommissionPrice") || 0,
    );

    const totalCertificateOrDeposit = Number(
      totalFinalServiceFee?.certificateOrDeposit || 0,
    );
    const totalAccountingFromPreviousPeriodOrAdvance = Number(
      totalFinalServiceFee?.accountingFromPreviousPeriodOrAdvance || 0,
    );
    const totalRemainingRevenueAfterAccounting = Number(
      totalFinalServiceFee?.remainingRevenueAfterAccounting || 0,
    );
    const totalPersonalIncomeTax = Number(
      totalFinalServiceFee?.personalIncomeTax || 0,
    );
    const totalRemainingRevenueAfterTax = Number(
      totalFinalServiceFee?.remainingRevenueAfterTax || 0,
    );
    const totalBonus = Number(totalFinalServiceFee?.bonus || 0);

    // Tổng TGĐ (tỉ lệ + tiền) — BẮT BUỘC lưu để export chia đúng khi căn nhiều NBC.
    // Thiếu 2 trường này thì export không chia được -> mỗi dòng bị full (x2).
    const managerTotalsForSave = calcTotalManagers(managers || []);

    const dataFormat = {
      lockingId,
      period,
      // month: Number(month),
      // year: Number(year),
      calculateCommissionRate, // TTDA
      confirmCommissionStatus: status,
      saleOpeningEventMechanismParametersId,
      //
      kRate: Number(mechanismParameters?.kRate || kRate), // Hệ số K
      priceForCommission: Number(priceForCommission), // Giá tính PDV
      standardWorkingDaysInMonth: Number(standardWorkingDaysInMonth), // Ngày công chuẩn
      transactionRate: Number(transactionRate), // Tỉ lệ GD
      incomeRate: Number(mechanismParameters?.incomeRate || incomeRate), // Tỉ lệ TN MSH
      platformIncomeRate: Number(
        mechanismParameters?.platformIncomeRate || platformIncomeRate,
      ), // Tỉ lệ TN sàn
      salesCommissionRate: Number(
        mechanismParameters?.salesCommissionRate || salesCommissionRate,
      ), // Tỉ lệ PDV CVKD
      eliteSalesCommissionRate: Number(
        mechanismParameters?.eliteSalesCommissionRate ||
          eliteSalesCommissionRate,
      ), // Tỉ lệ PDV CVKD Elite
      priceTNSan: Number(mechanismParameters?.priceTNSan || priceTNSan), // Số tiền TN sàn
      //
      displayReferralPrice: Number(displayReferralPrice), // Số tiền hưởng người giới thiệu
      commissionRateBlockManagerDH: Number(commissionRateBlockManagerDH), // Tỉ lệ PDV GDKDH
      commissionRateBlockManagerDT: Number(commissionRateBlockManagerDT), // Tỉ lệ PDV GDKDT
      commissionRateBlockManagerCL: Number(commissionRateBlockManagerCL), // Tỉ lệ PDV GDKCL
      commissionRateAreaManagerDH: Number(commissionRateAreaManagerDH), // Tỉ lệ PDV GDVDH
      commissionRateAreaManagerDT: Number(commissionRateAreaManagerDT), // Tỉ lệ PDV GDVDT
      commissionRateAreaManagerCL: Number(commissionRateAreaManagerCL), // Tỉ lệ PDV GDVCL
      commissionRateGeneralDirector: Number(commissionRateGeneralDirector), // Tỉ lệ PDV TGD
      //
      totalAllCommissionRate: Number(totalAllCommissionRate), // Tổng Tỉ lệ PDV
      totalAllCommissionPrice: Number(totalAllCommissionPrice), // Tổng PDV
      totalCertificateOrDeposit, // Tổng Chứng chỉ/ ký quỹ
      totalAccountingFromPreviousPeriodOrAdvance, // Tổng KT do đã ĐK kì trước/Đã tạm ứng/KT khác
      totalRemainingRevenueAfterAccounting, // Tổng PDV còn lại sau KT
      totalPersonalIncomeTax, // Tổng Thuế TNCN
      totalRemainingRevenueAfterTax, // Tổng PDV còn lại sau thuế
      totalBonus, // Tổng Thưởng khác
      //
      informationForm: {
        kRate,
        calculateCommissionRate,
        month,
        year,
        priceForCommission,
        standardWorkingDaysInMonth,
        transactionRate,
        incomeRate,
        platformIncomeRate,
        salesCommissionRate,
        eliteSalesCommissionRate,
        priceTNSan,
        //
        displayReferralPrice,
        commissionRateBlockManagerDH,
        commissionRateBlockManagerDT,
        commissionRateBlockManagerCL,
        commissionRateAreaManagerDH,
        commissionRateAreaManagerDT,
        commissionRateAreaManagerCL,
        commissionRateGeneralDirector,
      },
      relativeParticipantForm: {
        list: relativeParticipant,
        totals: {
          totalRelativeParticipantIncomePrice,
          totalRelativeParticipantCommissionPrice,
        },
      },
      saleBlockManagersForm: {
        list: saleBlockManagers,
        totals: {
          totalSaleBlockManagerCommissionRate,
          totalSaleBlockManagerCommissionPrice,
        },
      },
      saleAreaManagersForm: {
        list: saleAreaManagers,
        totals: {
          totalSaleAreaManagerCommissionRate,
          totalSaleAreaManagerCommissionPrice,
        },
      },
      referralsForm: {
        list: referrals,
        totals: {
          totalReferralsCommissionRate,
          totalReferralsCommissionPrice,
        },
        checkedSwitch,
      },
      managersForm: {
        list: managers,
        totals: {
          totalManagerCommissionRate: safeNum(managerTotalsForSave.totalRate),
          totalManagerCommissionPrice: safeNum(managerTotalsForSave.totalPrice),
          totalAllCommissionRate,
          totalAllCommissionPrice,
        },
      },
      finalEmployeesForm: {
        list: finalEmployees,
        totals: totalFinalServiceFee,
      },
    };

    if (month && year) {
      dataFormat.month = Number(month);
      dataFormat.year = Number(year);
    }

    const listSaleBlockManagers = saleBlockManagers.find(
      (item) => !item?.isFake,
    );
    const listSaleAreaManagers = saleAreaManagers.find((item) => !item?.isFake);
    const listCommissionData = [
      ...relativeParticipant,
      ...(listSaleBlockManagers?.items || []),
      ...(listSaleAreaManagers?.items || []),
      ...referrals,
      ...managers,
    ];

    const list = listCommissionData
      .map((item) => {
        if (!item?.employeeId) return null;

        const obj = {
          lockingId,
          period,
          employeeId: item.employeeId,
          kda: kRate,
        };

        if (item?.serviceRate) obj.serviceRate = item.serviceRate;
        if (item?.workingRate) obj.workingRate = item.workingRate;
        if (item?.type) obj.type = item.type;
        if (item?.calculateCommissionRate)
          obj.calculateCommissionRate = calculateCommissionRate;
        if (item?.commissionRate) obj.commissionRate = item.commissionRate;
        if (item?.interpretation) obj.interpretation = item.interpretation;
        if (item?.workingDays) obj.workingDay = item.workingDays;
        if (locking?.totalValue) obj.price = Number(locking.totalValue);
        if (item?.totalCommission) obj.totalCommission = item.totalCommission;
        if (item?.commissionPrice) {
          obj.serviceFee = item.commissionPrice;
          obj.commissionPrice = item.commissionPrice;
        }
        if (item?.incomePrice) obj.incomePrice = item.incomePrice;
        if (item?.platformIncomePrice)
          obj.platformIncomePrice = item.platformIncomePrice;
        if (item?.salesCommissionPrice)
          obj.salesCommissionPrice = item.salesCommissionPrice;
        if (item?.eliteSalesCommissionPrice)
          obj.eliteSalesCommissionPrice = item.eliteSalesCommissionPrice;
        if (item?.mainSellerId) obj.mainSellerId = item.mainSellerId;

        return obj;
      })
      .filter(Boolean);

    const listFinal = finalEmployees
      .filter((item) => item?.employeeId)
      .map((item) => ({
        lockingId,
        period,
        employeeId: item.employeeId,
        ...(item?.amountHeld && { amountHeld: item.amountHeld }),
        ...(item?.commissionPrice && { commissionPrice: item.commissionPrice }),
        // Luôn gửi (kể cả 0): BE $set theo từng field, bỏ field thì IndividualServiceFee
        // giữ nguyên CCMG cũ (vd NV vừa có CCMG: 737,910 → 0 nhưng DB vẫn 737,910).
        certificateOrDeposit: Number(item?.certificateOrDeposit || 0),
        ...(item?.accountingFromPreviousPeriodOrAdvance && {
          accountingFromPreviousPeriodOrAdvance:
            item.accountingFromPreviousPeriodOrAdvance,
        }),
        ...(item?.remainingRevenueAfterAccounting && {
          remainingRevenueAfterAccounting: item.remainingRevenueAfterAccounting,
        }),
        ...(item?.personalIncomeTax && {
          personalIncomeTax: item.personalIncomeTax,
        }),
        ...(item?.remainingRevenueAfterTax && {
          remainingRevenueAfterTax: item.remainingRevenueAfterTax,
        }),
        ...(item?.bonus && { bonus: item.bonus }),
      }));

    dataFormat.list = list;
    dataFormat.listFinalEmployee = listFinal;

    const commissionData = {
      lockingId,
      period,
      calculateCommissionRate,
      list: list,
      listFinalEmployee: listFinal,
    };
    // console.log({ commissionData });
    try {
      const data = await lockingCall.approveCalculateCommission(
        lockingId,
        dataFormat,
      );
      if (data) {
        setIsConfirmCommissionStatus(true);
        await getLocking(lockingId);
        toast.dismiss(toastCreate);
        toast.success("Cập nhật trạng thái thành công");
      }
      toast.dismiss(toastCreate);
      onClose();
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  // check
  const parseDecimal = (v) => {
    if (v === undefined || v === null || v === "") return null;
    const s = String(v).trim().replace(",", ".");
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  };

  const onChangeTransactionRate = (e) => {
    const raw = e.target.value;
    const num = parseDecimal(raw);
    setValue("transactionRate", num ?? raw, {
      shouldDirty: true,
      shouldValidate: true,
    });
    setStepHandle(1);
  };

  const transactionRateValue = useWatch({
    control,
    name: "transactionRate",
  });

  return (
    <>
      <form onSubmit={handleSubmit(submitHandler)}>
        <Box w={"full"} position="relative">
          <Box w={"100%"} mt={"20px"}>
            <Text
              fontSize={"16px"}
              lineHeight={"19px"}
              fontWeight={"600"}
              color={"var(--color-header-employee)"}
              mb={"16px"}
            >
              Thông tin chung
            </Text>
            {/* 2 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Dự án
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {locking?.project?.name || ""}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Sản phẩm
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${locking?.apartment?.code || ""} ${
                    locking?.apartment ? `(${locking?.apartment?.name})` : ""
                  }`}
                </Text>
              </Box>
            </Flex>
            {/* 2 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Đợt mở bán
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {locking?.saleOpeningEvent?.name || "-"}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Khách hàng
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {locking?.customer?.name || "-"}
                </Text>
              </Box>
            </Flex>
            {/* 3 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Người tạo
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {locking?.booker?.fullName || ""}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Ngày khách hàng chuyển tiền / ngày cọc
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {formatDateDb(locking?.transactionDate || "")}
                </Text>
              </Box>
            </Flex>
            {/* Tháng/Năm đối chiếu */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={1}>
                <Text
                  color={"var(--color-label-employee)"}
                  fontSize={"12px"}
                  mb={"8px"}
                >
                  Tháng/Năm đối chiếu
                </Text>
                <InputGroup
                  w={"100%"}
                  position="relative"
                  zIndex={focusStates["monthYear"] ? 3 : 1}
                >
                  <DatePicker
                    selected={monthYearDate}
                    onChange={handleMonthYearChange}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    locale="vi"
                    isClearable
                    placeholderText="Chọn tháng/năm"
                    className="datePickerStyle"
                    onFocus={() => handleFocus("monthYear")}
                    onBlur={() => handleBlur("monthYear")}
                  />
                  {!monthYearDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                {(errors.month || errors.year) && (
                  <Text mt={"4px"} color={"red.500"} fontSize={"12px"}>
                    {errors.month?.message || errors.year?.message}
                  </Text>
                )}
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
              <Box flex={1} />
              <Box flex={1} />
            </Flex>
            {/* 3 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              {/* Đợt — ẩn, chỉ dùng cho form */}
              <Box flex={1} display={"none"}>
                <InputControl
                  type="number"
                  label="Đợt"
                  placeholder="Nhập đợt giao dịch"
                  // errors={errors.period}
                  // register={register("period")}
                  register={register(`period`)}
                  defaultValue={step.period}
                  errors={errors.period}
                  onFocus={() => handleFocus("period")}
                  onBlur={() => handleBlur("period")}
                  state={focusStates["period"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  disabled={true}
                />
              </Box>
              <Box flex={1}>
                {/* <InputControl
                  type="number"
                  label="Tỉ lệ GD (%)"
                  placeholder="Nhập tỉ lệ giao dịch"
                  register={register("transactionRate")}
                  errors={errors.transactionRate}
                  onFocus={() => handleFocus("transactionRate")}
                  onBlur={() => handleBlur("transactionRate")}
                  state={focusStates["transactionRate"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  step="any"
                  disabled={false}
                  // nếu InputControl support controlled value thì truyền:
                  value={transactionRateValue ?? ""}
                  onChangeData={() => setStepHandle(1)}
                /> */}
                <InputControl
                  type="text"
                  inputMode="decimal"
                  label="Tỉ lệ nhận về (%)"
                  placeholder="Nhập tỉ lệ giao dịch (vd: 55,56)"
                  value={transactionRateValue ?? ""}
                  onChange={(e) => {
                    const s = e.target.value.replace(/[^\d.,]/g, "");
                    setValue("transactionRate", s, {
                      shouldDirty: true,
                      shouldValidate: false,
                    });
                    setStepHandle(1);
                  }}
                  onBlur={() => {
                    const v = getValues("transactionRate");
                    const num = parseDecimal(v);
                    setValue("transactionRate", num, {
                      shouldDirty: true,
                      shouldValidate: true,
                    });
                  }}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>

              <Box flex={1}>
                <InputControl
                  type="number"
                  label="TTDA (%)"
                  placeholder="Nhập TTDA"
                  // errors={errors.calculateCommissionRate}
                  // register={register("calculateCommissionRate")}
                  register={register(`calculateCommissionRate`)}
                  defaultValue={step.calculateCommissionRate}
                  errors={errors.calculateCommissionRate}
                  onFocus={() => handleFocus("calculateCommissionRate")}
                  onBlur={() => handleBlur("calculateCommissionRate")}
                  state={focusStates["calculateCommissionRate"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  onChange={() => setStepHandle(1)}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
            </Flex>
            {/* 4 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={1}>
                <Box w={"100%"}>
                  <SelectControl
                    label="Chọn hệ số k"
                    dataOption={dataKRate}
                    selectedMain={watch(
                      "saleOpeningEventMechanismParametersId",
                    )}
                    placeholder="Chọn hệ số k"
                    onChange={onchangeSaleOpeningEventMechanismParametersId}
                    onFocus={() =>
                      handleFocus("saleOpeningEventMechanismParametersId")
                    }
                    onBlur={() =>
                      handleBlur("saleOpeningEventMechanismParametersId")
                    }
                    state={focusStates["saleOpeningEventMechanismParametersId"]}
                    registerProps={register(
                      "saleOpeningEventMechanismParametersId",
                    )}
                    errorMessage={errors.saleOpeningEventMechanismParametersId}
                    mwidth={"100%"}
                    isRequired={true}
                    onChangeData={() => setStepHandle(1)}
                  />
                </Box>
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
                {periodCompensation?.length > 0 && (
                  <Text
                    fontSize={"14px"}
                    mt={"6px"}
                    color={"var(--color-option-employee-hover)"}
                  >
                    (Đã thêm đợt bổ sung cho{" "}
                    {periodCompensation.map((item, index) => {
                      return `${index > 0 ? ", " : ""} đợt ${item?.period}`;
                    })}
                    )
                  </Text>
                )}
              </Box>
              <Box flex={1}>
                <InputControl
                  // type="number"
                  label="Giá tính PDV"
                  placeholder="Giá tính PDV"
                  errors={errors.priceForCommission}
                  register={register("priceForCommission")}
                  onFocus={() => handleFocus("priceForCommission")}
                  onBlur={() => handleBlur("priceForCommission")}
                  onChange={onChangePrice}
                  value={displayPrice}
                  state={focusStates["priceForCommission"]}
                  mwidth={"100%"}
                  onChangeData={() => setStepHandle(1)}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
            </Flex>
            {/* 5 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={1}>
                <InputControl
                  type="number"
                  label="Ngày công chuẩn"
                  placeholder="Nhập Ngày công chuẩn VD: 23.5"
                  errors={errors.standardWorkingDaysInMonth}
                  register={register("standardWorkingDaysInMonth")}
                  onFocus={() => handleFocus("standardWorkingDaysInMonth")}
                  onBlur={() => handleBlur("standardWorkingDaysInMonth")}
                  state={focusStates["standardWorkingDaysInMonth"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  onChangeData={() => setStepHandle(1)}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
              <Box flex={1}>
                <InputControl
                  type="number"
                  label="Tỉ lệ TN MSH (Đi kèm K) (%)"
                  placeholder="Nhập tỉ lệ TN MSH VD: 0.6"
                  errors={errors.incomeRate}
                  register={register("incomeRate")}
                  onFocus={() => handleFocus("incomeRate")}
                  onBlur={() => handleBlur("incomeRate")}
                  state={focusStates["incomeRate"]}
                  mwidth={"100%"}
                  defaultValue={"0.6"}
                  onlyPositiveNumbers={true}
                  onChangeData={() => {
                    setStepHandleRate((prev) => {
                      if (prev.includes("incomeRate")) return prev;
                      return [...prev, "incomeRate"];
                    });
                    setStepHandle(1);
                  }}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
            </Flex>
            {/* 6 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={1}>
                <InputControl
                  type="number"
                  label="Tỉ lệ TN sàn (%)"
                  placeholder="Nhập tỉ lệ TN sàn VD: 0.4"
                  errors={errors.platformIncomeRate}
                  register={register("platformIncomeRate")}
                  onFocus={() => handleFocus("platformIncomeRate")}
                  onBlur={() => handleBlur("platformIncomeRate")}
                  state={focusStates["platformIncomeRate"]}
                  mwidth={"100%"}
                  defaultValue={locking?.apartment?.rateTNSan || 0}
                  // defaultValue={"0.4"}
                  onlyPositiveNumbers={true}
                  onChangeData={() => {
                    setStepHandleRate((prev) => {
                      if (prev.includes("platformIncomeRate")) return prev;
                      return [...prev, "platformIncomeRate"];
                    });
                    setStepHandle(1);
                  }}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
              <Box flex={1}>
                <InputControl
                  // type="number"
                  label="Số tiền TN sàn"
                  placeholder="Số tiền TN sàn"
                  errors={errors.priceTNSan}
                  register={register("priceTNSan")}
                  onFocus={() => handleFocus("priceTNSan")}
                  onBlur={() => handleBlur("priceTNSan")}
                  onChange={onChangePriceTN}
                  value={displayPriceTN}
                  state={focusStates["priceTNSan"]}
                  mwidth={"100%"}
                  onChangeData={() => {
                    setStepHandleRate((prev) => {
                      if (prev.includes("priceTNSan")) return prev;
                      return [...prev, "priceTNSan"];
                    });
                    setStepHandle(1);
                  }}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
            </Flex>

            {/* 7 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={1}>
                <InputControl
                  type="number"
                  label="Tỉ lệ PDV CVKD (%)"
                  placeholder="Nhập tỉ lệ PDV CVKD VD: 1.5"
                  errors={errors.salesCommissionRate}
                  register={register("salesCommissionRate")}
                  onFocus={() => handleFocus("salesCommissionRate")}
                  onBlur={() => handleBlur("salesCommissionRate")}
                  state={focusStates["salesCommissionRate"]}
                  mwidth={"100%"}
                  defaultValue={"1.5"}
                  onlyPositiveNumbers={true}
                  onChangeData={() => {
                    setStepHandleRate((prev) => {
                      if (prev.includes("salesCommissionRate")) return prev;
                      return [...prev, "salesCommissionRate"];
                    });
                    setStepHandle(1);
                  }}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
              <Box flex={1}>
                <InputControl
                  type="number"
                  label="Tỉ lệ PDV CVKD Elite (%)"
                  placeholder="Nhập tỉ lệ PDV CVKD Elite VD: 0.2"
                  errors={errors.eliteSalesCommissionRate}
                  register={register("eliteSalesCommissionRate")}
                  onFocus={() => handleFocus("eliteSalesCommissionRate")}
                  onBlur={() => handleBlur("eliteSalesCommissionRate")}
                  state={focusStates["eliteSalesCommissionRate"]}
                  mwidth={"100%"}
                  defaultValue={"0.2"}
                  onlyPositiveNumbers={true}
                  onChangeData={() => {
                    setStepHandleRate((prev) => {
                      if (prev.includes("eliteSalesCommissionRate"))
                        return prev;
                      return [...prev, "eliteSalesCommissionRate"];
                    });
                    setStepHandle(1);
                  }}
                />
                <Text
                  mt={"6px"}
                  color={"var(--color-secondary)"}
                  fontSize={"14px"}
                  fontWeight={400}
                  minW={"140px"}
                >
                  (Cho phép chỉnh sửa)
                </Text>
              </Box>
            </Flex>
          </Box>
          <Box w={"100%"} mt={"40px"}>
            <Text
              fontSize={"16px"}
              lineHeight={"19px"}
              fontWeight={"600"}
              color="var(--color-option-employee-hover)"
              mb={"16px"}
            >
              Hệ số tính PDV
            </Text>
            <Box w={"100%"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Người giới thiệu DL
              </Text>
              {/* 4 */}
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={1}>
                  <InputControl
                    // type="number"
                    label="Số tiền hưởng"
                    placeholder="Số tiền hưởng"
                    errors={errors.displayReferralPrice}
                    register={register("displayReferralPrice")}
                    onFocus={() => handleFocus("displayReferralPrice")}
                    onBlur={() => handleBlur("displayReferralPrice")}
                    onChange={onChangeReferralPrice}
                    value={displayReferralPrice}
                    state={focusStates["displayReferralPrice"]}
                    mwidth={"100%"}
                    disabled={!checkedSwitch}
                    onChangeData={() => setStepHandle(1)}
                  />
                  {/* <Text
                    mt={"6px"}
                    color={"var(--color-secondary)"}
                    fontSize={"14px"}
                    fontWeight={400}
                    minW={"140px"}
                  >
                    (Cho phép chỉnh sửa)
                  </Text> */}
                </Box>
                <Box flex={1}>
                  <FormControl
                    display="flex"
                    flexDirection={"column"}
                    alignItems="flex-start"
                  >
                    <FormLabel
                      lineHeight={"15px"}
                      mb={2}
                      fontSize={{ base: "12px" }}
                      fontWeight={400}
                      htmlFor="email-alerts"
                      color={"var(--color-label-employee)"}
                    >
                      Tự động tính toán theo số tiền hưởng
                    </FormLabel>
                    <Switch
                      // checked={checkedSwitch}
                      // defaultChecked={checkedSwitch}
                      // onChange={(e) => setCheckedSwitch(e.target.checked)}
                      isChecked={checkedSwitch}
                      onChange={(e) => setCheckedSwitch(e.target.checked)}
                    />
                  </FormControl>
                </Box>
                <Box flex={1}></Box>
              </Flex>
            </Box>
            <Box w={"100%"} mt={"20px"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Giám đốc khối
              </Text>
              {/* 6 */}
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={1}>
                  <InputControl
                    type="number"
                    label="Tỉ lệ PDV GDKDH (%)"
                    placeholder="Nhập tỉ lệ PDV GDKDH VD: 0.8"
                    errors={errors.commissionRateBlockManagerDH}
                    register={register("commissionRateBlockManagerDH")}
                    onFocus={() => handleFocus("commissionRateBlockManagerDH")}
                    onBlur={() => handleBlur("commissionRateBlockManagerDH")}
                    state={focusStates["commissionRateBlockManagerDH"]}
                    mwidth={"100%"}
                    defaultValue={"0.1"}
                    onlyPositiveNumbers={true}
                    onChangeData={() => setStepHandle(1)}
                    isLockInput={true}
                  />
                  {/* <Text
                    mt={"6px"}
                    color={"var(--color-secondary)"}
                    fontSize={"14px"}
                    fontWeight={400}
                    minW={"140px"}
                  >
                    (Cho phép chỉnh sửa)
                  </Text> */}
                </Box>
                <Box flex={1}>
                  <InputControl
                    type="number"
                    label="Tỉ lệ PDV GDKDT (%)"
                    placeholder="Nhập tỉ lệ PDV GDKDT: 1.5"
                    errors={errors.commissionRateBlockManagerDT}
                    register={register("commissionRateBlockManagerDT")}
                    onFocus={() => handleFocus("commissionRateBlockManagerDT")}
                    onBlur={() => handleBlur("commissionRateBlockManagerDT")}
                    state={focusStates["commissionRateBlockManagerDT"]}
                    mwidth={"100%"}
                    defaultValue={"0.2"}
                    onlyPositiveNumbers={true}
                    onChangeData={() => setStepHandle(1)}
                    isLockInput={true}
                  />
                  {/* <Text
                    mt={"6px"}
                    color={"var(--color-secondary)"}
                    fontSize={"14px"}
                    fontWeight={400}
                    minW={"140px"}
                  >
                    (Cho phép chỉnh sửa)
                  </Text> */}
                </Box>
                <Box flex={1}>
                  <InputControl
                    type="number"
                    label="Tỉ lệ PDV GDKCL (%)"
                    placeholder="Nhập tỉ lệ PDV GDKCL VD: 0.2"
                    errors={errors.commissionRateBlockManagerCL}
                    register={register("commissionRateBlockManagerCL")}
                    onFocus={() => handleFocus("commissionRateBlockManagerCL")}
                    onBlur={() => handleBlur("commissionRateBlockManagerCL")}
                    state={focusStates["commissionRateBlockManagerCL"]}
                    mwidth={"100%"}
                    defaultValue={"0.2"}
                    onlyPositiveNumbers={true}
                    onChangeData={() => setStepHandle(1)}
                    isLockInput={true}
                  />
                  {/* <Text
                    mt={"6px"}
                    color={"var(--color-secondary)"}
                    fontSize={"14px"}
                    fontWeight={400}
                    minW={"140px"}
                  >
                    (Cho phép chỉnh sửa)
                  </Text> */}
                </Box>
              </Flex>
            </Box>
            <Box w={"100%"} mt={"20px"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Giám đốc vùng
              </Text>
              {/* 6 */}
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={1}>
                  <InputControl
                    type="number"
                    label="Tỉ lệ PDV GDVDH (%)"
                    placeholder="Nhập tỉ lệ PDV GDVDH VD: 0.8"
                    errors={errors.commissionRateAreaManagerDH}
                    register={register("commissionRateAreaManagerDH")}
                    onFocus={() => handleFocus("commissionRateAreaManagerDH")}
                    onBlur={() => handleBlur("commissionRateAreaManagerDH")}
                    state={focusStates["commissionRateAreaManagerDH"]}
                    mwidth={"100%"}
                    defaultValue={"0.06"}
                    onlyPositiveNumbers={true}
                    onChangeData={() => setStepHandle(1)}
                    isLockInput={true}
                  />
                  {/* <Text
                    mt={"6px"}
                    color={"var(--color-secondary)"}
                    fontSize={"14px"}
                    fontWeight={400}
                    minW={"140px"}
                  >
                    (Cho phép chỉnh sửa)
                  </Text> */}
                </Box>
                <Box flex={1}>
                  <InputControl
                    type="number"
                    label="Tỉ lệ PDV GDVDT (%)"
                    placeholder="Nhập tỉ lệ PDV GDVDT: 1.5"
                    errors={errors.commissionRateAreaManagerDT}
                    register={register("commissionRateAreaManagerDT")}
                    onFocus={() => handleFocus("commissionRateAreaManagerDT")}
                    onBlur={() => handleBlur("commissionRateAreaManagerDT")}
                    state={focusStates["commissionRateAreaManagerDT"]}
                    mwidth={"100%"}
                    defaultValue={"0.12"}
                    onlyPositiveNumbers={true}
                    onChangeData={() => setStepHandle(1)}
                    isLockInput={true}
                  />
                  {/* <Text
                    mt={"6px"}
                    color={"var(--color-secondary)"}
                    fontSize={"14px"}
                    fontWeight={400}
                    minW={"140px"}
                  >
                    (Cho phép chỉnh sửa)
                  </Text> */}
                </Box>
                <Box flex={1}>
                  <InputControl
                    type="number"
                    label="Tỉ lệ PDV GDVCL (%)"
                    placeholder="Nhập tỉ lệ PDV GDVCL VD: 0.2"
                    errors={errors.commissionRateAreaManagerCL}
                    register={register("commissionRateAreaManagerCL")}
                    onFocus={() => handleFocus("commissionRateAreaManagerCL")}
                    onBlur={() => handleBlur("commissionRateAreaManagerCL")}
                    state={focusStates["commissionRateAreaManagerCL"]}
                    mwidth={"100%"}
                    defaultValue={"0.12"}
                    onlyPositiveNumbers={true}
                    onChangeData={() => setStepHandle(1)}
                    isLockInput={true}
                  />
                  {/* <Text
                    mt={"6px"}
                    color={"var(--color-secondary)"}
                    fontSize={"14px"}
                    fontWeight={400}
                    minW={"140px"}
                  >
                    (Cho phép chỉnh sửa)
                  </Text> */}
                </Box>
              </Flex>
            </Box>
            <Box w={"100%"} mt={"20px"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Tổng giám đốc
              </Text>
              {/* 6 */}
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"12px"}
                w={"100%"}
              >
                <Box flex={1}>
                  <InputControl
                    type="number"
                    label="Tỉ lệ PDV TGD (%)"
                    placeholder="Nhập tỉ lệ PDV TGD: 0.8"
                    errors={errors.commissionRateGeneralDirector}
                    register={register("commissionRateGeneralDirector")}
                    onFocus={() => handleFocus("commissionRateGeneralDirector")}
                    onBlur={() => handleBlur("commissionRateGeneralDirector")}
                    state={focusStates["commissionRateGeneralDirector"]}
                    mwidth={"100%"}
                    defaultValue={"0.2"}
                    onlyPositiveNumbers={true}
                    onChangeData={() => setStepHandle(1)}
                    isLockInput={true}
                  />
                </Box>
                <Box flex={1}></Box>
                <Box flex={1}></Box>
              </Flex>
            </Box>
          </Box>

          {/* button */}
          {/* {locking?.confirmCommissionStatus !==
             ConfirmCommissionStatus.APPROVED && ( */}
          <Box
            position="fixed"
            top="16px"
            right="12px"
            zIndex={10}
            display="flex"
            alignItems="center"
          >
            <SlideFade in={isActionOpen} offsetX={20} unmountOnExit>
              <Stack
                direction="row"
                spacing={2}
                align="center"
                mr={2}
                bg="white"
                p="8px"
                borderRadius="12px"
                boxShadow="md"
              >
                <Button
                  size="sm"
                  lineHeight="18px"
                  fontSize="12px"
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  backgroundImage="var(--linear-gradient-excel)"
                  _hover={{ filter: "brightness(90%)" }}
                  type="submit"
                  isLoading={isLoading}
                >
                  Tính toán
                </Button>

                {issCalculate && stepHandle !== 1 && (
                  <Button
                    size="sm"
                    lineHeight="18px"
                    fontSize="12px"
                    fontWeight={600}
                    color={"var(--color-main)"}
                    borderRadius={"8px"}
                    backgroundImage="var(--linear-gradient-excel)"
                    _hover={{ filter: "brightness(90%)" }}
                    onClick={handleCaculateFinalEmployees}
                    isLoading={isLoadingCalculateFinal}
                  >
                    Tính toán phí giao dịch cuối cùng
                  </Button>
                )}

                {issCalculate &&
                  isCalculateFinalServiceFee &&
                  stepHandle !== 1 && (
                    <Button
                      size="sm"
                      lineHeight="18px"
                      fontSize="12px"
                      fontWeight={600}
                      color={"var(--color-main)"}
                      borderRadius={"8px"}
                      background="var(--linear-gradient-employee)"
                      _hover={{ filter: "brightness(90%)" }}
                      onClick={onOpen}
                    >
                      Xác nhận
                    </Button>
                  )}
              </Stack>
            </SlideFade>

            {/* Nút toggle */}
            <IconButton
              aria-label="Toggle actions"
              size="sm"
              borderRadius="full"
              color={"var(--color-main)"}
              backgroundImage="var(--linear-gradient-excel)"
              _hover={{ filter: "brightness(90%)" }}
              icon={isActionOpen ? <FiChevronRight /> : <FiChevronLeft />}
              onClick={() => setIsActionOpen((prev) => !prev)}
            />
          </Box>

          {/* )} */}

          <Box mt={6}>
            <ActionWarning
              issCalculate={issCalculate}
              isCalculateFinalServiceFee={isCalculateFinalServiceFee}
              stepHandle={stepHandle}
              forAction="calculate"
            />
          </Box>

          {/* button */}
          <Box
            display="flex"
            justifyContent={"flex-start"}
            p={"24px 0"}
            gap={4}
          >
            <Button
              p={"13px 45px"}
              lineHeight={"18px"}
              fontSize={"15px"}
              fontWeight={600}
              color={"var(--color-main)"}
              borderRadius={"8px"}
              backgroundImage="var(--linear-gradient-excel)"
              _hover={{
                filter: "brightness(90%)",
              }}
              type="submit"
              isLoading={isLoading}
            >
              Tính toán
            </Button>
          </Box>

          <Skeleton isLoaded={!isLoading}>
            {issCalculate && relativeParticipant && (
              <Box w="100%" mt="20px">
                <Text
                  fontSize={"16px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                  mb={"16px"}
                >
                  Nhân viên tham gia
                </Text>
                {relativeParticipant?.length > 0 ? (
                  <Box>
                    {relativeParticipant.map((item, index) => {
                      return (
                        <Box key={item.employeeId + "_" + index}>
                          <StepEmployeeForm
                            lockingId={lockingId}
                            locking={locking}
                            item={item}
                            index={index}
                            onChangeRow={handleEmployeeChange}
                            setStepHandle={setStepHandle}
                          />
                        </Box>
                      );
                    })}
                    <Box
                      w={"full"}
                      border={"0.5px solid var(--color-option-employee-hover)"}
                      my={3}
                    ></Box>
                    {/* Tổng */}
                    <Text
                      fontSize={"14px"}
                      lineHeight={"19px"}
                      fontWeight={"600"}
                      color={"var(--color-header-employee)"}
                      mb={"16px"}
                    >
                      Tổng PDV nhân viên
                    </Text>
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      gap={"27px"}
                      mb={"12px"}
                      w={"100%"}
                    >
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="Tổng TN"
                          placeholder="Tổng TN"
                          errors={errors.totalRelativeParticipantIncomePrice}
                          register={register(
                            "totalRelativeParticipantIncomePrice",
                          )}
                          onFocus={() =>
                            handleFocus("totalRelativeParticipantIncomePrice")
                          }
                          onBlur={() =>
                            handleBlur("totalRelativeParticipantIncomePrice")
                          }
                          onChange={onChangeTotalRelativeParticipantIncomePrice}
                          value={totalRelativeParticipantIncomePrice}
                          state={
                            focusStates["totalRelativeParticipantIncomePrice"]
                          }
                          mwidth={"100%"}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="Tổng PDV"
                          placeholder="Tổng PDV"
                          errors={errors.totalRelativeParticipantCommission}
                          register={register(
                            "totalRelativeParticipantCommission",
                          )}
                          onFocus={() =>
                            handleFocus("totalRelativeParticipantCommission")
                          }
                          onBlur={() =>
                            handleBlur("totalRelativeParticipantCommission")
                          }
                          onChange={onChangeTotalRelativeParticipantCommission}
                          value={totalRelativeParticipantCommission}
                          state={
                            focusStates["totalRelativeParticipantCommission"]
                          }
                          mwidth={"100%"}
                          isLockInput={true}
                          readOnly={true}
                        />
                      </Box>
                    </Flex>
                  </Box>
                ) : (
                  <Text color="red">Không có nhân viên tham gia</Text>
                )}
              </Box>
            )}
            {issCalculate && saleBlockManagers && (
              <Box w="100%" mt="40px">
                <Text
                  fontSize={"16px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                  mb={"16px"}
                >
                  Giám đốc khối tham gia
                </Text>
                {saleBlockManagers?.length > 0 ? (
                  <Box>
                    {saleBlockManagers.map((participant, managerIndex) => (
                      <Box key={participant.employeeId + "_" + managerIndex}>
                        <Box mt="20px">
                          {participant?.employee?.fullName && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Người bán chính:{" "}
                                {participant?.employee?.fullName}
                              </Text>
                            </Flex>
                          )}
                          {participant?.commissionRate && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Tỉ lệ:{" "}
                                {participant?.mainSellerCommissionRate ||
                                  participant?.commissionRate}{" "}
                                %
                              </Text>
                            </Flex>
                          )}
                          <Box
                            w={"full"}
                            border={
                              "0.5px solid var(--color-option-employee-hover)"
                            }
                            mb={3}
                          ></Box>
                        </Box>
                        {participant?.items?.map((item, itemIndex) => {
                          const title =
                            itemIndex === 0
                              ? "GDKDH"
                              : itemIndex === 1
                                ? "GDKDT"
                                : itemIndex === 2
                                  ? "GDKCL"
                                  : "CTV";
                          return (
                            <Box key={item.employeeId + "_" + itemIndex}>
                              <Step3ManagerBlockAreaForm
                                lockingId={lockingId}
                                locking={locking}
                                item={item}
                                index={itemIndex} // item index
                                parentIndex={managerIndex} // manager index
                                onChangeRow={handleSaleBlockManagerChange}
                                title={title}
                                handleRemoveRow={
                                  handleSaleBlockManagerRemoveRow
                                }
                                setStepHandle={setStepHandle}
                                mainSellerCommissionRate={item?.mainSellerRate}
                              />
                            </Box>
                          );
                        })}
                      </Box>
                    ))}
                    <Box
                      w={"full"}
                      border={"0.5px solid var(--color-option-employee-hover)"}
                      my={3}
                    ></Box>
                    {/* Tổng */}
                    <Text
                      fontSize={"14px"}
                      lineHeight={"19px"}
                      fontWeight={"600"}
                      color={"var(--color-header-employee)"}
                      mb={"16px"}
                    >
                      Tổng PDV giám đốc khối
                    </Text>
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      gap={"27px"}
                      mb={"12px"}
                      w={"100%"}
                    >
                      <Box flex={1}>
                        <InputControl
                          type="number"
                          // label="Tổng tỉ lệ PDV (%)"
                          placeholder="Tổng tỉ lệ PDV"
                          errors={errors.totalSaleBlockManagerCommissionRate}
                          register={register(
                            "totalSaleBlockManagerCommissionRate",
                          )}
                          value={watch("totalSaleBlockManagerCommissionRate")}
                          onFocus={() =>
                            handleFocus("totalSaleBlockManagerCommissionRate")
                          }
                          onBlur={() =>
                            handleBlur("totalSaleBlockManagerCommissionRate")
                          }
                          defaultValue={0}
                          state={
                            focusStates["totalSaleBlockManagerCommissionRate"]
                          }
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          isLockInput={true}
                          readOnly={true}
                          unit={"%"}
                          unitTextMode={true}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          // label="Tổng PDV"
                          placeholder="Tổng PDV"
                          errors={errors.totalSaleBlockManagerCommissionPrice}
                          register={register(
                            "totalSaleBlockManagerCommissionPrice",
                          )}
                          onFocus={() =>
                            handleFocus("totalSaleBlockManagerCommissionPrice")
                          }
                          onBlur={() =>
                            handleBlur("totalSaleBlockManagerCommissionPrice")
                          }
                          onChange={
                            onChangeTotalSaleBlockManagerCommissionPrice
                          }
                          value={totalSaleBlockManagerCommissionPrice}
                          state={
                            focusStates["totalSaleBlockManagerCommissionPrice"]
                          }
                          mwidth={"100%"}
                          isLockInput={true}
                          readOnly={true}
                        />
                      </Box>
                    </Flex>
                  </Box>
                ) : (
                  <Text color="red">Không có giám đốc khối tham gia</Text>
                )}
              </Box>
            )}
            {issCalculate && saleAreaManagers && (
              <Box w="100%" mt="40px">
                <Text
                  fontSize={"16px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                  mb={"16px"}
                >
                  Giám đốc vùng tham gia
                </Text>
                {saleAreaManagers?.length > 0 ? (
                  <Box>
                    {saleAreaManagers.map((participant, managerIndex) => (
                      <Box key={participant.employeeId + "_" + managerIndex}>
                        <Box mt="20px">
                          {participant?.employee?.fullName && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Người bán chính:{" "}
                                {participant?.employee?.fullName}
                              </Text>
                            </Flex>
                          )}
                          {participant?.commissionRate && (
                            <Flex gap={1}>
                              <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text>
                              <Text
                                fontSize={"14px"}
                                lineHeight={"19px"}
                                fontWeight={"500"}
                                color={"var(--color-header-employee)"}
                                mb={"16px"}
                              >
                                Tỉ lệ:{" "}
                                {participant?.mainSellerCommissionRate ||
                                  participant?.commissionRate}{" "}
                                %
                              </Text>
                            </Flex>
                          )}
                          <Box
                            w={"full"}
                            border={
                              "0.5px solid var(--color-option-employee-hover)"
                            }
                            mb={3}
                          ></Box>
                        </Box>
                        {participant?.items?.map((item, itemIndex) => {
                          const title =
                            itemIndex === 0
                              ? "GDVDH"
                              : itemIndex === 1
                                ? "GDVDT"
                                : itemIndex === 2
                                  ? "GDVCL"
                                  : "CTV";
                          return (
                            <Box key={item.employeeId + "_" + itemIndex}>
                              <Step3ManagerBlockAreaForm
                                lockingId={lockingId}
                                locking={locking}
                                item={item}
                                index={itemIndex} // item index
                                parentIndex={managerIndex} // manager index
                                onChangeRow={handleSaleAreaManagerChange}
                                title={title}
                                handleRemoveRow={handleSaleAreaManagerRemoveRow}
                                setStepHandle={setStepHandle}
                                mainSellerCommissionRate={item?.mainSellerRate}
                              />
                            </Box>
                          );
                        })}
                      </Box>
                    ))}
                    <Box
                      w={"full"}
                      border={"0.5px solid var(--color-option-employee-hover)"}
                      my={3}
                    ></Box>
                    {/* Tổng */}
                    <Text
                      fontSize={"14px"}
                      lineHeight={"19px"}
                      fontWeight={"600"}
                      color={"var(--color-header-employee)"}
                      mb={"16px"}
                    >
                      Tổng PDV giám đốc vùng
                    </Text>
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      gap={"27px"}
                      mb={"12px"}
                      w={"100%"}
                    >
                      <Box flex={1}>
                        <InputControl
                          type="number"
                          // label="Tổng tỉ lệ PDV (%)"
                          placeholder="Tổng tỉ lệ PDV"
                          errors={errors.totalSaleAreaManagerCommissionRate}
                          register={register(
                            "totalSaleAreaManagerCommissionRate",
                          )}
                          value={watch("totalSaleAreaManagerCommissionRate")}
                          onFocus={() =>
                            handleFocus("totalSaleAreaManagerCommissionRate")
                          }
                          onBlur={() =>
                            handleBlur("totalSaleAreaManagerCommissionRate")
                          }
                          defaultValue={0}
                          state={
                            focusStates["totalSaleAreaManagerCommissionRate"]
                          }
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          isLockInput={true}
                          readOnly={true}
                          unit={"%"}
                          unitTextMode={true}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          // label="Tổng PDV"
                          placeholder="Tổng PDV"
                          errors={errors.totalSaleAreaManagerCommissionPrice}
                          register={register(
                            "totalSaleAreaManagerCommissionPrice",
                          )}
                          onFocus={() =>
                            handleFocus("totalSaleAreaManagerCommissionPrice")
                          }
                          onBlur={() =>
                            handleBlur("totalSaleAreaManagerCommissionPrice")
                          }
                          onChange={onChangeTotalSaleAreaManagerCommissionPrice}
                          value={totalSaleAreaManagerCommissionPrice}
                          state={
                            focusStates["totalSaleAreaManagerCommissionPrice"]
                          }
                          mwidth={"100%"}
                          isLockInput={true}
                          readOnly={true}
                        />
                      </Box>
                    </Flex>
                  </Box>
                ) : (
                  <Text color="red">Không có giám đốc vùng tham gia</Text>
                )}
              </Box>
            )}
            {issCalculate && referrals && (
              <Box w="100%" mt="40px">
                <Text
                  fontSize={"16px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                  mb={"16px"}
                >
                  Người GTDL tham gia
                </Text>
                {referrals?.length > 0 ? (
                  <Box>
                    {referrals.map((item, index) => (
                      <Box key={item.employeeId + "_" + index}>
                        <StepManagerForm
                          lockingId={lockingId}
                          locking={locking}
                          item={item}
                          index={index}
                          onChangeRow={handleReferralsChange}
                          title={"Người GTDL"}
                          isShowRef={true}
                          isShowCommissionRate={false}
                          // isShowWorkingDays={false}
                          handleRemoveRow={handleReferralsRemoveRow}
                          checkedSwitch={checkedSwitch}
                          setStepHandle={setStepHandle}
                        />
                      </Box>
                    ))}
                    <Box
                      w={"full"}
                      border={"0.5px solid var(--color-option-employee-hover)"}
                      my={3}
                    ></Box>
                    {/* Tổng */}
                    <Text
                      fontSize={"14px"}
                      lineHeight={"19px"}
                      fontWeight={"600"}
                      color={"var(--color-header-employee)"}
                      mb={"16px"}
                    >
                      Tổng PDV người GTDL
                    </Text>
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      gap={"27px"}
                      mb={"12px"}
                      w={"100%"}
                    >
                      {/* <Box flex={1}>
                        <InputControl
                          type="number"
                          label="Tổng tỉ lệ PDV (%)"
                          placeholder="Tổng tỉ lệ PDV"
                          errors={errors.totalReferralsCommissionRate}
                          register={register("totalReferralsCommissionRate")}
                          onFocus={() =>
                            handleFocus("totalReferralsCommissionRate")
                          }
                          onBlur={() =>
                            handleBlur("totalReferralsCommissionRate")
                          }
                          defaultValue={0}
                          state={focusStates["totalReferralsCommissionRate"]}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                        />
                      </Box> */}
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="Tổng PDV"
                          placeholder="Tổng PDV"
                          errors={errors.totalReferralsCommissionPrice}
                          register={register("totalReferralsCommissionPrice")}
                          onFocus={() =>
                            handleFocus("totalReferralsCommissionPrice")
                          }
                          onBlur={() =>
                            handleBlur("totalReferralsCommissionPrice")
                          }
                          onChange={onChangeTotalReferralsCommissionPrice}
                          value={totalReferralsCommissionPrice}
                          state={focusStates["totalReferralsCommissionPrice"]}
                          mwidth={"100%"}
                          isLockInput={true}
                          readOnly={true}
                        />
                      </Box>
                    </Flex>
                  </Box>
                ) : (
                  <Text color="red">Không có người GTDL tham gia</Text>
                )}
              </Box>
            )}
            {issCalculate && managers && (
              <Box w="100%" mt="40px">
                <Text
                  fontSize={"16px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                  mb={"16px"}
                >
                  Giám đốc tham gia
                </Text>
                {managers?.length > 0 ? (
                  <Box>
                    {managers.map((item, index) => (
                      <Box key={item.employeeId + "_" + index}>
                        <StepManagerForm
                          lockingId={lockingId}
                          locking={locking}
                          item={item}
                          index={index}
                          onChangeRow={handleManagerChange}
                          title={"Tổng giám đốc"}
                          isShowWorkingDays={false}
                          // disabledRate={true}
                          handleRemoveRow={handleManagerRemoveRow}
                          mainSellerCommissionRate={
                            item?.mainSellerCommissionRate
                          }
                        />
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Text color="red">Không có giám đốc tham gia</Text>
                )}
              </Box>
            )}
            {issCalculate && relativeParticipant && (
              <Box w="100%" mt="40px">
                <Flex
                  alignItems={"center"}
                  gap={"16px"}
                  mb={"16px"}
                  w={"100%"}
                >
                  <Text
                    fontSize={"16px"}
                    lineHeight={"19px"}
                    fontWeight={"600"}
                    color="var(--color-option-employee-hover)"
                  >
                    Tổng PDV cả căn
                  </Text>
                  <Box>
                    <InputControl
                      // type="number"
                      // label="Tổng PDV"
                      placeholder="Tổng PDV"
                      errors={errors.totalAllCommissionPrice}
                      register={register("totalAllCommissionPrice")}
                      onFocus={() => handleFocus("totalAllCommissionPrice")}
                      onBlur={() => handleBlur("totalAllCommissionPrice")}
                      onChange={onChangeTotalAllCommissionPrice}
                      value={totalAllCommissionPrice}
                      state={focusStates["totalAllCommissionPrice"]}
                      mwidth={"100%"}
                      isLockInput={true}
                      readOnly={true}
                      fontSize={"16px"}
                      autoWidth={true}
                    />
                  </Box>
                </Flex>
                {/* <Box>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                  >
                    <Box flex={1}>
                      <InputControl
                        type="number"
                        // label="Tổng tỉ lệ PDV (%)"
                        placeholder="Tổng tỉ lệ PDV"
                        errors={errors.totalAllCommissionRate}
                        register={register("totalAllCommissionRate")}
                        value={watch("totalAllCommissionRate")}
                        onFocus={() => handleFocus("totalAllCommissionRate")}
                        onBlur={() => handleBlur("totalAllCommissionRate")}
                        defaultValue={0}
                        state={focusStates["totalAllCommissionRate"]}
                        onlyPositiveNumbers={true}
                        mwidth={"100%"}
                        isLockInput={true}
                        readOnly={true}
                        // unit={"%"}
                        // unitTextMode={true}
                      />
                    </Box>
                  </Flex>
                </Box> */}
              </Box>
            )}
          </Skeleton>

          {issCalculate && stepHandle !== 1 && (
            <Box mt={6}>
              <ActionWarning
                issCalculate={issCalculate}
                isCalculateFinalServiceFee={isCalculateFinalServiceFee}
                stepHandle={stepHandle}
                forAction="final"
              />

              <Box
                display="flex"
                justifyContent={"flex-start"}
                p={"24px 0"}
                gap={4}
              >
                <Button
                  p={"13px 45px"}
                  lineHeight={"18px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  backgroundImage="var(--linear-gradient-excel)"
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  onClick={handleCaculateFinalEmployees}
                  isLoading={isLoadingCalculateFinal}
                >
                  Tính toán phí giao dịch cuối cùng
                </Button>
              </Box>
            </Box>
          )}

          <Skeleton isLoaded={!isLoadingCalculateFinal}>
            {issCalculate && isCalculateFinalServiceFee && finalEmployees && (
              <Box w="100%" mt="40px">
                <Text
                  fontSize={"16px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                  mb={"16px"}
                >
                  Phí giao dịch theo căn
                </Text>
                {finalEmployees?.length > 0 ? (
                  <Box>
                    {finalEmployees.map((item, index) => (
                      <Box key={item.employeeId + "_" + index}>
                        <Step3FinalServiceFeeForm
                          lockingId={lockingId}
                          locking={locking}
                          item={item}
                          index={index}
                          onChangeRow={handleFinalEmployeesChange}
                          title={"Người tham gia"}
                          isShowWorkingDays={false}
                          disabledRate={true}
                          handleRemoveRow={handleFinalEmployeesRemoveRow}
                          calcTotalPDV={calcTotalPDV}
                        />
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Text color="red">Không có người tham gia</Text>
                )}
              </Box>
            )}
            {issCalculate && isCalculateFinalServiceFee && finalEmployees && (
              <Box w="100%" mt="40px">
                <Text
                  fontSize={"16px"}
                  lineHeight={"19px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                  mb={"16px"}
                >
                  Tổng cộng
                </Text>
                <Box w={"100%"}>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"12px"}
                    w={"100%"}
                    flexWrap={"wrap"}
                  >
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      gap={"27px"}
                      mb={"12px"}
                      w={"100%"}
                      flexWrap={"wrap"}
                    >
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="Số tiền"
                          placeholder="Số tiền"
                          value={formatPriceUS(
                            Math.round(totalFinalServiceFee.commissionPrice),
                          )}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          readonly={true}
                          isLockInput={true}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="Thưởng khác"
                          placeholder="Thưởng khác"
                          value={formatPriceUS(
                            Math.round(totalFinalServiceFee.bonus),
                          )}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          readonly={true}
                          isLockInput={true}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="Chứng chỉ/ ký quỹ"
                          placeholder="Chứng chỉ/ ký quỹ"
                          value={formatPriceUS(
                            Math.round(
                              totalFinalServiceFee.certificateOrDeposit,
                            ),
                          )}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          readonly={true}
                          isLockInput={true}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="KT do đã ĐK kì trước/Đã tạm ứng/KT khác"
                          placeholder="KT do đã ĐK kì trước/Đã tạm ứng/KT khác"
                          value={formatPriceUS(
                            Math.round(
                              totalFinalServiceFee.accountingFromPreviousPeriodOrAdvance,
                            ),
                          )}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          readonly={true}
                          isLockInput={true}
                        />
                      </Box>
                    </Flex>
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      gap={"27px"}
                      mb={"12px"}
                      w={"100%"}
                      flexWrap={"wrap"}
                    >
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="PDV còn lại sau KT"
                          placeholder="PDV còn lại sau KT"
                          value={formatPriceUS(
                            Math.round(
                              totalFinalServiceFee.remainingRevenueAfterAccounting,
                            ),
                          )}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          readonly={true}
                          isLockInput={true}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="Thuế TNCN"
                          placeholder="Thuế TNCN"
                          value={formatPriceUS(
                            Math.round(totalFinalServiceFee.personalIncomeTax),
                          )}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          readonly={true}
                          isLockInput={true}
                        />
                      </Box>
                      <Box flex={1}>
                        <InputControl
                          // type="number"
                          label="PDV còn lại sau thuế"
                          placeholder="PDV còn lại sau thuế"
                          value={formatPriceUS(
                            Math.round(
                              totalFinalServiceFee.remainingRevenueAfterTax,
                            ),
                          )}
                          onlyPositiveNumbers={true}
                          mwidth={"100%"}
                          readonly={true}
                          isLockInput={true}
                        />
                      </Box>
                    </Flex>
                  </Flex>
                </Box>
              </Box>
            )}
          </Skeleton>

          {issCalculate && isCalculateFinalServiceFee && (
            <Box mt={6}>
              <ActionWarning
                issCalculate={issCalculate}
                isCalculateFinalServiceFee={isCalculateFinalServiceFee}
                stepHandle={stepHandle}
                forAction="confirm"
              />
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                {stepHandle !== 1 && (
                  <Box
                    display="flex"
                    justifyContent={"flex-start"}
                    w={"100%"}
                    p={"24px 0"}
                    gap={4}
                  >
                    <Button
                      // type="submit"
                      p={"13px 45px"}
                      lineHeight={"18px"}
                      fontSize={"15px"}
                      fontWeight={600}
                      color={"var(--color-main)"}
                      borderRadius={"8px"}
                      background="var(--linear-gradient-employee)"
                      _hover={{
                        filter: "brightness(90%)",
                      }}
                      onClick={onOpen}
                    >
                      Xác nhận
                    </Button>
                  </Box>
                )}

                <Box
                  display="flex"
                  w={"100%"}
                  justifyContent={"flex-end"}
                  p={"24px 0"}
                  gap={4}
                >
                  <Button
                    // type="submit"
                    p={"13px 45px"}
                    lineHeight={"18px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-main)"}
                    borderRadius={"8px"}
                    bg={"var(--color-option-employee-hover)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Chi tiết đợt bù
                  </Button>
                </Box>
                {/* {locking?.confirmCommissionStatus !==
                ConfirmCommissionStatus.APPROVED && ( */}
                {/* )}  */}
              </Flex>
            </Box>
          )}
        </Box>
      </form>

      <Box ref={bottomRef} h="1px" />

      {/* modal */}
      {issCalculate && isCalculateFinalServiceFee && (
        <DeleteDialog
          isOpen={isOpen}
          onClose={onClose}
          title={"Duyệt phí dịch vụ"}
          description={
            <Flex display={"inline"}>
              Bạn có chắc chắn muốn duyệt phí dịch vụ với kết quả tính toán này
              ?
            </Flex>
          }
          textDelete={"Xác nhận"}
          action={() => approveCommission(lockingId)}
        />
      )}
      {/* {issCalculate &&
        isCalculateFinalServiceFee &&
        isConfirmCommissionStatus && (
          <DeleteDialog
            isOpen={isOpenApproved}
            onClose={onCloseApproved}
            title={"Thông báo"}
            description={
              <Flex display={"inline"}>
                Đợt thanh toán này đã được xác nhận!
              </Flex>
            }
            isNotification={true}
          />
        )} */}
    </>
  );
});

const ActionWarning = memo(function ActionWarning({
  issCalculate,
  isCalculateFinalServiceFee,
  stepHandle,
  forAction = "calculate", // "calculate" | "final" | "confirm"
}) {
  const needReCalculate = issCalculate && stepHandle === 1;

  // ===== NÚT 1: TÍNH TOÁN =====
  if (forAction === "calculate") {
    // Chưa tính lần nào
    if (!issCalculate) {
      return (
        <Box
          bg="yellow.50"
          border="1px solid"
          borderColor="yellow.300"
          borderRadius="12px"
          p="10px 12px"
          maxW="680px"
          boxShadow="sm"
        >
          <HStack spacing={2} align="flex-start">
            <Box mt="2px">
              <FiAlertTriangle />
            </Box>
            <Box>
              <Text fontSize="12px" fontWeight={700}>
                Lưu ý thao tác
              </Text>
              <Text fontSize="12px">
                Sau khi chỉnh <b>Thông tin chung</b> ➜ hãy bấm <b>Tính toán</b>.
              </Text>
            </Box>
          </HStack>
        </Box>
      );
    }

    // Đã tính rồi nhưng vừa sửa => cần tính lại
    if (needReCalculate) {
      return (
        <Box
          bg="orange.50"
          border="1px solid"
          borderColor="orange.300"
          borderRadius="12px"
          p="10px 12px"
          maxW="720px"
          boxShadow="sm"
        >
          <HStack spacing={2} align="flex-start">
            <Box mt="2px">
              <FiAlertTriangle />
            </Box>
            <Box>
              <Text fontSize="12px" fontWeight={700}>
                Bạn vừa sửa dữ liệu
              </Text>
              <Text fontSize="12px">
                Vui lòng bấm lại <b>Tính toán</b> để cập nhật kết quả mới.
              </Text>
            </Box>
          </HStack>
        </Box>
      );
    }

    // Base OK
    return (
      <Box
        bg="green.50"
        border="1px solid"
        borderColor="green.300"
        borderRadius="12px"
        p="10px 12px"
        maxW="720px"
        boxShadow="sm"
      >
        <Text fontSize="12px" fontWeight={700}>
          Đã tính xong bước 1 ✅
        </Text>
        <Text fontSize="12px">
          Bạn có thể qua bước tiếp theo:{" "}
          <b>Tính toán phí giao dịch cuối cùng</b>.
        </Text>
      </Box>
    );
  }

  // ===== NÚT 2: TÍNH TOÁN PHÍ CUỐI CÙNG =====
  if (forAction === "final") {
    // Chưa tính base
    if (!issCalculate) {
      return (
        <Box
          bg="yellow.50"
          border="1px solid"
          borderColor="yellow.300"
          borderRadius="12px"
          p="10px 12px"
          maxW="720px"
          boxShadow="sm"
        >
          <HStack spacing={2} align="flex-start">
            <Box mt="2px">
              <FiAlertTriangle />
            </Box>
            <Box>
              <Text fontSize="12px" fontWeight={700}>
                Chưa thể tính phí cuối cùng
              </Text>
              <Text fontSize="12px">
                Hãy bấm <b>Tính toán</b> trước.
              </Text>
            </Box>
          </HStack>
        </Box>
      );
    }

    // Sửa sau khi tính base
    if (needReCalculate) {
      return (
        <Box
          bg="orange.50"
          border="1px solid"
          borderColor="orange.300"
          borderRadius="12px"
          p="10px 12px"
          maxW="720px"
          boxShadow="sm"
        >
          <HStack spacing={2} align="flex-start">
            <Box mt="2px">
              <FiAlertTriangle />
            </Box>
            <Box>
              <Text fontSize="12px" fontWeight={700}>
                Bạn vừa sửa dữ liệu sau khi tính toán
              </Text>
              <Text fontSize="12px">
                Vui lòng bấm lại theo thứ tự: <b>1) Tính toán</b> ➜{" "}
                <b>2) Tính toán phí giao dịch cuối cùng</b>
              </Text>
            </Box>
          </HStack>
        </Box>
      );
    }

    // Đã có final rồi
    if (isCalculateFinalServiceFee) {
      return (
        <Box
          bg="green.50"
          border="1px solid"
          borderColor="green.300"
          borderRadius="12px"
          p="10px 12px"
          maxW="720px"
          boxShadow="sm"
        >
          <Text fontSize="12px" fontWeight={700}>
            Đã tính phí cuối cùng ✅
          </Text>
          <Text fontSize="12px">
            Bạn có thể <b>Xác nhận</b> luôn.
          </Text>
        </Box>
      );
    }

    // Base OK, chưa final
    return (
      <Box
        bg="blue.50"
        border="1px solid"
        borderColor="blue.300"
        borderRadius="12px"
        p="10px 12px"
        maxW="720px"
        boxShadow="sm"
      >
        <Text fontSize="12px" fontWeight={700}>
          Bước tiếp theo
        </Text>
        <Text fontSize="12px">
          Bấm <b>Tính toán phí giao dịch cuối cùng</b> để ra bảng “Phí giao dịch
          theo căn”.
        </Text>
      </Box>
    );
  }

  // ===== NÚT 3: XÁC NHẬN =====
  if (forAction === "confirm") {
    // Chưa có final
    if (!isCalculateFinalServiceFee) {
      return (
        <Box
          bg="yellow.50"
          border="1px solid"
          borderColor="yellow.300"
          borderRadius="12px"
          p="10px 12px"
          maxW="720px"
          boxShadow="sm"
        >
          <HStack spacing={2} align="flex-start">
            <Box mt="2px">
              <FiAlertTriangle />
            </Box>
            <Box>
              <Text fontSize="12px" fontWeight={700}>
                Chưa thể xác nhận
              </Text>
              <Text fontSize="12px">
                Hãy bấm <b>Tính toán phí giao dịch cuối cùng</b> trước.
              </Text>
            </Box>
          </HStack>
        </Box>
      );
    }

    // Có final nhưng sửa dữ liệu => bắt tính lại
    if (needReCalculate) {
      return (
        <Box
          bg="orange.50"
          border="1px solid"
          borderColor="orange.300"
          borderRadius="12px"
          p="10px 12px"
          maxW="720px"
          boxShadow="sm"
        >
          <HStack spacing={2} align="flex-start">
            <Box mt="2px">
              <FiAlertTriangle />
            </Box>
            <Box>
              <Text fontSize="12px" fontWeight={700}>
                Bạn vừa sửa dữ liệu sau khi đã tính phí cuối cùng
              </Text>
              <Text fontSize="12px">
                Vui lòng bấm lại: <b>1) Tính toán</b> ➜{" "}
                <b>2) Tính toán phí giao dịch cuối cùng</b>
              </Text>
            </Box>
          </HStack>
        </Box>
      );
    }

    // Xác nhận OK
    return (
      <Box
        bg="green.50"
        border="1px solid"
        borderColor="green.300"
        borderRadius="12px"
        p="10px 12px"
        maxW="720px"
        boxShadow="sm"
      >
        <Text fontSize="12px" fontWeight={700}>
          Bạn có thể xác nhận ngay ✅
        </Text>
        <Text fontSize="12px">
          Nếu bạn chỉ chỉnh <b>Phí giao dịch theo căn</b> ➜ không cần tính lại,
          bấm <b>Xác nhận</b> luôn.
        </Text>
      </Box>
    );
  }

  return null;
});
